export enum Languages{
  ENGLISH=1,
  DUTCH=2,
  FRENCH=3,
  GERMAN=4,
  SLOVAK=5,
  BRAZIL=6,
  SPANISH=7,
  COUNT=8
}

export enum LangIds{
  TIPS_Head1=1,
  TIPS_Head2=2,
  TIPS_Lightning1=3,
  TIPS_Lightning2=4,
  TIPS_Lightning3=5,
  TIPS_Table1=6,
  TIPS_Table2=7,
  TIPS_Table3=8,
  TIPS_reflections1=9,
  TIPS_reflections2=10,
  TIPS_reflections3=11,

  ACCEPT_ErrAccept=101,
  ACCEPT_Lets=102,
  ACCEPT_First=103,
  ACCEPT_Terms1=104,
  ACCEPT_Terms2=105,
  ACCEPT_Terms3=106,
  ACCEPT_Terms4=107,
  ACCEPT_Terms5=108,
  ACCEPT_Sharing=109,

  TURN_Doc = 301,

  ERROR_Retake = 350,
  BUTTON_Continue=352,
  LOGO_Powered=353,

  SELFIE_Header = 201,
  SELFIE_Headnum = 202,
  SELFIE_Name = 203,
  SELFIE_Desc1 = 204,
  SELFIE_Desc2 = 205,
  SELFIE_Take = 206,
  SELFIE_Terms1 = 207,
  SELFIE_Terms2 = 208,

  PROCESS_Processing = 250,

  MAIN_Selfie = 601,
  MAIN_Remove = 602,
  MAIN_RemoveSucceeded = 603,
  MAIN_RemoveSucceededText = 604,
  MAIN_RemoveVisitor = 605,
  MAIN_Capture = 606,
  MAIN_HeaderNum1 = 607,
  MAIN_HeaderNum2 = 608,
  MAIN_HeaderNum3 = 609,
  MAIN_HeaderNum4 = 610,
  MAIN_Child = 611,
  MAIN_ChildSucceeded = 612,
  MAIN_ChildSucceededText = 613,
  MAIN_Results = 614,
  MAIN_ResultsSucceeded = 615,
  MAIN_ResultsSucceededText = 616,
  MAIN_Retake = 617,
  MAIN_Review = 618,

  SCANID_Capture = 701,
  SCANID_Front = 702,
  SCANID_Back = 703,
  SCANID_candidate_selection = 704,
  SCANID_document_centering = 705,
  SCANID_document_not_present = 706,
  SCANID_document_too_far = 707,
  SCANID_sharpness_too_low = 708,
  SCANID_brightness_too_low = 709,
  SCANID_brightness_too_high = 710,
  SCANID_hotspots_present = 711,
  SCANID_loading = 712,
  SCANID_waiting = 713,

  SCANFACE_Selfie=801,
  SCANFACE_candidate_selection=802,
  SCANFACE_face_too_close=803,
  SCANFACE_face_too_far=804,
  SCANFACE_face_centering=805,
  SCANFACE_face_not_present=806,
  SCANFACE_sharpness_too_low=807,
  SCANFACE_brightness_too_low=808,
  SCANFACE_brightness_too_high=809,
  SCANFACE_device_pitched=810,
  SCANFACE_loading=811,
  SCANFACE_waiting=812,

  SUMMARY_Header = 901,
  SUMMARY_Headnum = 902,
  SUMMARY_Email = 903,
  SUMMARY_EmailError = 904,
  SUMMARY_Age = 905,
  SUMMARY_AgeError = 906,
  SUMMARY_Gender = 907,
  SUMMARY_GenderError = 908,
  SUMMARY_GivenNames = 909,
  SUMMARY_GivenNamesError = 910,
  SUMMARY_Surname = 911,
  SUMMARY_SurnameError = 912,
  SUMMARY_Fullname = 913,
  SUMMARY_FullnameError = 914,
  SUMMARY_Address = 915,
  SUMMARY_AddressError = 916,
  SUMMARY_DateOfBirth = 917,
  SUMMARY_DateOfBirthError = 918,
  SUMMARY_PersonalNumber = 919,
  SUMMARY_PersonalNumberError = 920,
  SUMMARY_Citizenship = 921,
  SUMMARY_CitizenshipError = 922,
  SUMMARY_Nationality = 923,
  SUMMARY_NationalityError = 924,
  SUMMARY_DocCountry = 925,
  SUMMARY_DocCountryError = 926,
  SUMMARY_DocEdition = 927,
  SUMMARY_DocEditionError = 928,
  SUMMARY_DocType = 929,
  SUMMARY_DocTypeError = 930,
  SUMMARY_DocIssue = 931,
  SUMMARY_DocIssueError = 932,
  SUMMARY_DocExpiry = 933,
  SUMMARY_DocExpiryError = 934,
  SUMMARY_DocNumber = 935,
  SUMMARY_DocNumberError = 936,
  SUMMARY_Retake = 937,

  SERVER_Err = 1101,
  SERVER_Err_front_fail = 1102,
  SERVER_Err_front_fail_ext = 1103,
  SERVER_Err_front_exp = 1104,
  SERVER_Err_front_exp_ext = 1105,
  SERVER_Err_front_change = 1106,
  SERVER_Err_front_change_ext = 1107,
  SERVER_Err_back_fail = 1108,
  SERVER_Err_back_fail_ext = 1109,
  SERVER_Err_back_exp = 1110,
  SERVER_Err_back_exp_ext = 1111,
  SERVER_Err_back_change = 1112,
  SERVER_Err_back_change_ext = 1113,
  SERVER_Err_face_in = 1114,
  SERVER_Err_face_in_ext = 1115,
  SERVER_Err_face_liveness = 1116,
  SERVER_Err_face_liveness_ext = 1117,
  SERVER_Err_face_ban = 1118,
  SERVER_Err_face_ban_ext = 1119,
  SERVER_Err_face_spoof = 1120,
  SERVER_Err_face_spoof_ext = 1121,
  SERVER_Err_child_in = 1122,
  SERVER_Err_child_in_ext = 1123,
  SERVER_Err_child_liveness = 1124,
  SERVER_Err_child_liveness_ext = 1125,
  SERVER_Err_child_ban = 1126,
  SERVER_Err_child_ban_ext = 1127,
  SERVER_Err_child_spoof = 1128,
  SERVER_Err_child_spoof_ext = 1129,
  SERVER_Err_child_old = 1130,
  SERVER_Err_child_old_ext = 1131,
}

/*-----------------------------------ENGLISH-------------------------------------*/
var englishLangs: string[] = [];
englishLangs[LangIds.BUTTON_Continue] = 'Continue';
englishLangs[LangIds.LOGO_Powered] = 'POWERED BY';

englishLangs[LangIds.TURN_Doc] = 'Turn document card to the back side';

englishLangs[LangIds.TIPS_Head1] = 'Tips for successful ';
englishLangs[LangIds.TIPS_Head2] = 'document capture';
englishLangs[LangIds.TIPS_Lightning1] = 'Make sure you have ';
englishLangs[LangIds.TIPS_Lightning2] = 'good lighting conditions';
englishLangs[LangIds.TIPS_Lightning3] = ' in the room';
englishLangs[LangIds.TIPS_Table1] = 'Place the identity ';
englishLangs[LangIds.TIPS_Table2] = 'document on a table';
englishLangs[LangIds.TIPS_Table3] = ' with a different colour when taking a photo';
englishLangs[LangIds.TIPS_reflections1] = 'To ';
englishLangs[LangIds.TIPS_reflections2] = 'prevent reflections';
englishLangs[LangIds.TIPS_reflections3] = ' on the document, turn it facing away the light';

englishLangs[LangIds.ACCEPT_ErrAccept] = 'You must accept the terms to continue.';
englishLangs[LangIds.ACCEPT_Lets] = 'Let’s get started';
englishLangs[LangIds.ACCEPT_First] = 'You will first capture both sides of your valid identity document while we extract your data so you don’t have to type it manually. Then, you will take a selfie to match with the document image.';
englishLangs[LangIds.ACCEPT_Terms1] = 'I accept the ';
englishLangs[LangIds.ACCEPT_Terms2] = 'Terms of Use';
englishLangs[LangIds.ACCEPT_Terms3] = ' and ';
englishLangs[LangIds.ACCEPT_Terms4] = 'Privacy Policy';
englishLangs[LangIds.ACCEPT_Terms5] = ' for using FaceTicket. I give my explicit consent for the processing and storing of my personal data for the purpose of entering the venue.';
englishLangs[LangIds.ACCEPT_Sharing] = 'I accept sharing my data for receiving personalized communication from the event organizers.';

englishLangs[LangIds.SELFIE_Header] = 'Take a selfie';
englishLangs[LangIds.SELFIE_Headnum] = '3/4';
englishLangs[LangIds.SELFIE_Name] = 'Let\'s take a selfie';
englishLangs[LangIds.SELFIE_Desc1] = 'Keep your phone vertical';
englishLangs[LangIds.SELFIE_Desc2] = ' and at eye level when taking the photo of your face.';
englishLangs[LangIds.SELFIE_Take] = 'Take a selfie';
englishLangs[LangIds.SELFIE_Terms1] = 'Dávam výslovný súhlas so spracovaním a uchovávaním mojich osobných údajov na účely vstupu na miesto konania podujatia. Potvrdzujem, že som si prečítal, porozumel a súhlasím s ';
englishLangs[LangIds.SELFIE_Terms2] = 'Podmienkami používania';

englishLangs[LangIds.PROCESS_Processing] = 'Processing....';

englishLangs[LangIds.ERROR_Retake] = 'Retake';

englishLangs[LangIds.MAIN_Selfie] = 'Take a selfie';
englishLangs[LangIds.MAIN_Remove] = 'Remove customer';
englishLangs[LangIds.MAIN_RemoveSucceeded] = 'Removal succeeded';
englishLangs[LangIds.MAIN_RemoveSucceededText] = 'You have successfully deleted your purchase.';
englishLangs[LangIds.MAIN_RemoveVisitor] = 'Remove customer %VISITORNAME% including all tickets?';
englishLangs[LangIds.MAIN_Capture] = 'Capture ID';
englishLangs[LangIds.MAIN_HeaderNum1] = '1/4';
englishLangs[LangIds.MAIN_HeaderNum2] = '2/4';
englishLangs[LangIds.MAIN_HeaderNum3] = '3/4';
englishLangs[LangIds.MAIN_HeaderNum4] = '4/4';
englishLangs[LangIds.MAIN_Child] = 'Child ticket verification';
englishLangs[LangIds.MAIN_ChildSucceeded] = 'Verification succeeded';
englishLangs[LangIds.MAIN_ChildSucceededText] = 'We have sent you a ticket confirmation to your email.';
englishLangs[LangIds.MAIN_Results] = 'Results';
englishLangs[LangIds.MAIN_ResultsSucceeded] = 'Verification succeeded';
englishLangs[LangIds.MAIN_ResultsSucceededText] = 'We have sent you a ticket confirmation to your email.';
englishLangs[LangIds.MAIN_Retake] = 'Do you really want to retake your data?';
englishLangs[LangIds.MAIN_Review] = 'Review Details';

englishLangs[LangIds.SCANID_Capture] = 'Capture ID';
englishLangs[LangIds.SCANID_Front] = 'Front side';
englishLangs[LangIds.SCANID_Back] = 'Back side';
englishLangs[LangIds.SCANID_candidate_selection] = 'Hold still…';
englishLangs[LangIds.SCANID_document_centering] = 'Place document in rectangle';
englishLangs[LangIds.SCANID_document_not_present] = 'Place document in rectangle';
englishLangs[LangIds.SCANID_document_too_far] = 'Move closer';
englishLangs[LangIds.SCANID_sharpness_too_low] = 'More light needed';
englishLangs[LangIds.SCANID_brightness_too_low] = 'More light needed';
englishLangs[LangIds.SCANID_brightness_too_high] = 'Less light needed';
englishLangs[LangIds.SCANID_hotspots_present] = 'Avoid reflections';
englishLangs[LangIds.SCANID_loading] = 'Loading. Please wait.';
englishLangs[LangIds.SCANID_waiting] = 'Processing. Please wait.';

englishLangs[LangIds.SCANFACE_Selfie] = 'Take a selfie';
englishLangs[LangIds.SCANFACE_candidate_selection] = 'Stay still…';
englishLangs[LangIds.SCANFACE_face_too_close] = 'Move back';
englishLangs[LangIds.SCANFACE_face_too_far] = 'Move closer';
englishLangs[LangIds.SCANFACE_face_centering] = 'Center your face';
englishLangs[LangIds.SCANFACE_face_not_present] = 'Position your face into the circle';
englishLangs[LangIds.SCANFACE_sharpness_too_low] = 'Turn face against light';
englishLangs[LangIds.SCANFACE_brightness_too_low] = 'Turn face against light';
englishLangs[LangIds.SCANFACE_brightness_too_high] = 'Less light needed';
englishLangs[LangIds.SCANFACE_device_pitched] = 'Hold your phone at eye level';
englishLangs[LangIds.SCANFACE_loading] = 'Loading. Please wait.';
englishLangs[LangIds.SCANFACE_waiting] = 'Processing. Please wait.';

englishLangs[LangIds.SUMMARY_Header] = 'Review Details';
englishLangs[LangIds.SUMMARY_Headnum] = '2/4';
englishLangs[LangIds.SUMMARY_Email] = 'Email';
englishLangs[LangIds.SUMMARY_EmailError] = 'Your email address is not valid.';
englishLangs[LangIds.SUMMARY_Age] = 'Age';
englishLangs[LangIds.SUMMARY_AgeError] = 'Your age is not a valid number.';
englishLangs[LangIds.SUMMARY_Gender] = 'Gender';
englishLangs[LangIds.SUMMARY_GenderError] = 'Enter your gender.';
englishLangs[LangIds.SUMMARY_GivenNames] = 'Given names';
englishLangs[LangIds.SUMMARY_GivenNamesError] = 'Enter your given names.';
englishLangs[LangIds.SUMMARY_Surname] = 'Surname';
englishLangs[LangIds.SUMMARY_SurnameError] = 'Enter your surname.';
englishLangs[LangIds.SUMMARY_Fullname] = 'Full name';
englishLangs[LangIds.SUMMARY_FullnameError] = 'Enter your full name.';
englishLangs[LangIds.SUMMARY_Address] = 'Address';
englishLangs[LangIds.SUMMARY_AddressError] = 'Enter your address.';
englishLangs[LangIds.SUMMARY_DateOfBirth] = 'Date of birth';
englishLangs[LangIds.SUMMARY_DateOfBirthError] = 'Enter your date of birth.';
englishLangs[LangIds.SUMMARY_PersonalNumber] = 'Personal number';
englishLangs[LangIds.SUMMARY_PersonalNumberError] = 'Enter your personal number.';
englishLangs[LangIds.SUMMARY_Citizenship] = 'Citizenship';
englishLangs[LangIds.SUMMARY_CitizenshipError] = 'Enter your citizenship.';
englishLangs[LangIds.SUMMARY_Nationality] = 'Nationality';
englishLangs[LangIds.SUMMARY_NationalityError] = 'Enter your nationality.';
englishLangs[LangIds.SUMMARY_DocCountry] = 'Document country';
englishLangs[LangIds.SUMMARY_DocCountryError] = 'Enter your document country.';
englishLangs[LangIds.SUMMARY_DocEdition] = 'Document edition';
englishLangs[LangIds.SUMMARY_DocEditionError] = 'Enter your document edition.';
englishLangs[LangIds.SUMMARY_DocType] = 'Document type';
englishLangs[LangIds.SUMMARY_DocTypeError] = 'Enter your document type.';
englishLangs[LangIds.SUMMARY_DocIssue] = 'Document issue';
englishLangs[LangIds.SUMMARY_DocIssueError] = 'Enter your document issue.';
englishLangs[LangIds.SUMMARY_DocExpiry] = 'Document expiry';
englishLangs[LangIds.SUMMARY_DocExpiryError] = 'Enter your document expiry.';
englishLangs[LangIds.SUMMARY_DocNumber] = 'Document number';
englishLangs[LangIds.SUMMARY_DocNumberError] = 'Enter your document number.';
englishLangs[LangIds.SUMMARY_Retake] = 'Retake';

englishLangs[LangIds.SERVER_Err] = 'Something went wrong. Please try again.';
englishLangs[LangIds.SERVER_Err_front_fail] = 'Your document scan failed.';
englishLangs[LangIds.SERVER_Err_front_fail_ext] = 'Please scan the FRONT SIDE of your id card.';
englishLangs[LangIds.SERVER_Err_front_exp] = 'Your ID is expired';
englishLangs[LangIds.SERVER_Err_front_exp_ext] = 'You won\'t be able to proceed.';
englishLangs[LangIds.SERVER_Err_front_change] = 'Sorry, it seems there\'s an issue with your ID.';
englishLangs[LangIds.SERVER_Err_front_change_ext] = 'You won\'t be able to proceed.';
englishLangs[LangIds.SERVER_Err_back_fail] = 'Your document scan failed.';
englishLangs[LangIds.SERVER_Err_back_fail_ext] = 'Please scan the BACK SIDE of your id card.';
englishLangs[LangIds.SERVER_Err_back_exp] = 'Your ID is expired';
englishLangs[LangIds.SERVER_Err_back_exp_ext] = 'You won\'t be able to proceed.';
englishLangs[LangIds.SERVER_Err_back_change] = 'Sorry, it seems there\'s an issue with your ID.';
englishLangs[LangIds.SERVER_Err_back_change_ext] = 'You won\'t be able to proceed.';
englishLangs[LangIds.SERVER_Err_face_in] = 'Your face is linked to another ticket';
englishLangs[LangIds.SERVER_Err_face_in_ext] = 'Start over with different ticket owner.';
englishLangs[LangIds.SERVER_Err_face_liveness] = 'Face verification failed';
englishLangs[LangIds.SERVER_Err_face_liveness_ext] = 'Looks like the selfie you have taken does not have sufficient quality.';
englishLangs[LangIds.SERVER_Err_face_ban] = 'You are not allowed to purchase tickets due to the ongoing stadium ban';
englishLangs[LangIds.SERVER_Err_face_ban_ext] = 'Start over with different ticket owner.';
englishLangs[LangIds.SERVER_Err_face_spoof] = 'Face verification failed';
englishLangs[LangIds.SERVER_Err_face_spoof_ext] = 'Face from your id doesn\'t match with the selfie.';
englishLangs[LangIds.SERVER_Err_child_in] = 'Your face is linked to another ticket';
englishLangs[LangIds.SERVER_Err_child_in_ext] = 'Start over with different ticket owner.';
englishLangs[LangIds.SERVER_Err_child_liveness] = 'Face verification failed';
englishLangs[LangIds.SERVER_Err_child_liveness_ext] = 'Looks like the selfie you have taken does not have sufficient quality.';
englishLangs[LangIds.SERVER_Err_child_ban] = 'You are not allowed to purchase tickets due to the ongoing stadium ban';
englishLangs[LangIds.SERVER_Err_child_ban_ext] = 'Start over with different ticket owner.';
englishLangs[LangIds.SERVER_Err_child_spoof] = 'Face verification failed';
englishLangs[LangIds.SERVER_Err_child_spoof_ext] = 'Face from your id doesn\'t match with the selfie.';
englishLangs[LangIds.SERVER_Err_child_old] = 'Looks like you are over 15';
englishLangs[LangIds.SERVER_Err_child_old_ext] = 'Start over with different ticket owner.';
/*-----------------------------------ENGLISH-------------------------------------*/

/*-----------------------------------FRENCH--------------------------------------*/
var frenchLangs: string[] = [];
frenchLangs[LangIds.BUTTON_Continue] = 'Continuer';
frenchLangs[LangIds.LOGO_Powered] = 'PROPULSÉ PAR';

frenchLangs[LangIds.TURN_Doc] = 'Retournez la carte de document au verso';

frenchLangs[LangIds.TIPS_Head1] = 'Conseils pour une ';
frenchLangs[LangIds.TIPS_Head2] = 'capture de document réussie';
frenchLangs[LangIds.TIPS_Lightning1] = 'Veillez à ce que les ';
frenchLangs[LangIds.TIPS_Lightning2] = 'conditions d\'éclairage soient bonnes';
frenchLangs[LangIds.TIPS_Lightning3] = ' dans la pièce';
frenchLangs[LangIds.TIPS_Table1] = 'Placez le ';
frenchLangs[LangIds.TIPS_Table2] = 'document d\'identité sur une table';
frenchLangs[LangIds.TIPS_Table3] = ' de couleur différente lorsque vous prenez une photo';
frenchLangs[LangIds.TIPS_reflections1] = 'Pour ';
frenchLangs[LangIds.TIPS_reflections2] = 'éviter les reflets';
frenchLangs[LangIds.TIPS_reflections3] = ' sur le document, tournez-le à l\'opposé de la lumière';

frenchLangs[LangIds.ACCEPT_ErrAccept] = 'Vous devez accepter les conditions pour continuer.';
frenchLangs[LangIds.ACCEPT_Lets] = 'Commençons';
frenchLangs[LangIds.ACCEPT_First] = 'Vous allez d\'abord photographier les deux côtés de votre document d\'identité valide pendant que nous extrayons vos données afin que vous n\'ayez pas à les entrer manuellement. Ensuite, vous prendrez un selfie qui correspondra à l\'image du document.';
frenchLangs[LangIds.ACCEPT_Terms1] = 'J\'accepte les ';
frenchLangs[LangIds.ACCEPT_Terms2] = 'Conditions d\'utilisation';
frenchLangs[LangIds.ACCEPT_Terms3] = ' et la ';
frenchLangs[LangIds.ACCEPT_Terms4] = 'Politique de confidentialité';
frenchLangs[LangIds.ACCEPT_Terms5] = ' pour l\'utilisation de FaceTicket. Je donne mon consentement explicite au traitement et au stockage de mes données personnelles dans le but d\'entrer dans le stade.';
frenchLangs[LangIds.ACCEPT_Sharing] = 'J\'accepte de partager mes données pour recevoir des communications personnalisées de la part des organisateurs de l\'événement.';

frenchLangs[LangIds.SELFIE_Header] = 'Prenez un selfie.';
frenchLangs[LangIds.SELFIE_Headnum] = '3/4';
frenchLangs[LangIds.SELFIE_Name] = 'Prenons un selfie.';
frenchLangs[LangIds.SELFIE_Desc1] = 'Gardez votre téléphone verticalement';
frenchLangs[LangIds.SELFIE_Desc2] = ' et au niveau des yeux lorsque vous prenez la photo de votre visage.'
frenchLangs[LangIds.SELFIE_Take] = 'Prenez un selfie.';
frenchLangs[LangIds.SELFIE_Terms1] = 'Dávam výslovný súhlas so spracovaním a uchovávaním mojich osobných údajov na účely vstupu na miesto konania podujatia. Potvrdzujem, že som si prečítal, porozumel a súhlasím s ';
frenchLangs[LangIds.SELFIE_Terms2] = 'Podmienkami používania';

frenchLangs[LangIds.PROCESS_Processing] = 'Traitement....';

frenchLangs[LangIds.ERROR_Retake] = 'Reprendre';

frenchLangs[LangIds.MAIN_Selfie] = 'Prenez un selfie.'; 
frenchLangs[LangIds.MAIN_Remove] = 'Supprimer le client';
frenchLangs[LangIds.MAIN_RemoveSucceeded] = 'Suppression réussie';
frenchLangs[LangIds.MAIN_RemoveSucceededText] = 'Vous avez supprimé votre achat avec succès.'; 
frenchLangs[LangIds.MAIN_RemoveVisitor] = 'Supprimer le client %VISITORNAME% y compris tous les billets ?'; 
frenchLangs[LangIds.MAIN_Capture] = 'Capturer ID';
frenchLangs[LangIds.MAIN_HeaderNum1] = '1/4'; 
frenchLangs[LangIds.MAIN_HeaderNum2] = '2/4'; 
frenchLangs[LangIds.MAIN_HeaderNum3] = '3/4'; 
frenchLangs[LangIds.MAIN_HeaderNum4] = '4/4';
frenchLangs[LangIds.MAIN_Child] = 'Vérification du billet enfant'; 
frenchLangs[LangIds.MAIN_ChildSucceeded] = 'Vérification réussie';
frenchLangs[LangIds.MAIN_ChildSucceededText] = 'Nous vous avons envoyé une confirmation de billet par email.'; 
frenchLangs[LangIds.MAIN_Results] = 'Résultats';
frenchLangs[LangIds.MAIN_ResultsSucceeded] = 'Vérification réussie';
frenchLangs[LangIds.MAIN_ResultsSucceededText] = 'Nous vous avons envoyé une confirmation de billet par email.'; 
frenchLangs[LangIds.MAIN_Retake] = 'Voulez-vous vraiment reprendre vos données ?';
frenchLangs[LangIds.MAIN_Review] = 'Vérifier les détails';

frenchLangs[LangIds.SCANID_Capture] = 'Capturer ID';
frenchLangs[LangIds.SCANID_Front] = 'Côté avant';
frenchLangs[LangIds.SCANID_Back] = 'Côté arrière';
frenchLangs[LangIds.SCANID_candidate_selection] = 'Restez immobile…';
frenchLangs[LangIds.SCANID_document_centering] = 'Placez le document dans le rectangle';
frenchLangs[LangIds.SCANID_document_not_present] = 'Placez le document dans le rectangle';
frenchLangs[LangIds.SCANID_document_too_far] = 'Approchez-vous';
frenchLangs[LangIds.SCANID_sharpness_too_low] = 'Plus de lumière nécessaire';
frenchLangs[LangIds.SCANID_brightness_too_low] = 'Plus de lumière nécessaire';
frenchLangs[LangIds.SCANID_brightness_too_high] = 'Moins de lumière nécessaire';
frenchLangs[LangIds.SCANID_hotspots_present] = 'Évitez les reflets';
frenchLangs[LangIds.SCANID_loading] = 'Chargement. Veuillez patienter.';
frenchLangs[LangIds.SCANID_waiting] = 'Traitement. Veuillez patienter.';

frenchLangs[LangIds.SCANFACE_Selfie] = 'Prenez un selfie.';
frenchLangs[LangIds.SCANFACE_candidate_selection] = 'Restez immobile…';
frenchLangs[LangIds.SCANFACE_face_too_close] = 'Reculez';
frenchLangs[LangIds.SCANFACE_face_too_far] = 'Approchez-vous';
frenchLangs[LangIds.SCANFACE_face_centering] = 'Centrez votre visage';
frenchLangs[LangIds.SCANFACE_face_not_present] = 'Positionnez votre visage dans le cercle';
frenchLangs[LangIds.SCANFACE_sharpness_too_low] = 'Tournez votre visage vers la lumière';
frenchLangs[LangIds.SCANFACE_brightness_too_low] = 'Tournez votre visage vers la lumière';
frenchLangs[LangIds.SCANFACE_brightness_too_high] = 'Moins de lumière nécessaire';
frenchLangs[LangIds.SCANFACE_device_pitched] = 'Tenez votre téléphone au niveau des yeux';
frenchLangs[LangIds.SCANFACE_loading] = 'Veuillez patienter…';
frenchLangs[LangIds.SCANFACE_waiting] = 'Veuillez patienter…';

frenchLangs[LangIds.SUMMARY_Header] = 'Vérifier les détails';
frenchLangs[LangIds.SUMMARY_Headnum] = '2/4';
frenchLangs[LangIds.SUMMARY_Email] = 'Email';
frenchLangs[LangIds.SUMMARY_EmailError] = 'Votre adresse email n\'est pas valide.';
frenchLangs[LangIds.SUMMARY_Age] = ' ge';
frenchLangs[LangIds.SUMMARY_AgeError] = 'Votre âge n\'est pas un nombre valide.';
frenchLangs[LangIds.SUMMARY_Gender] = 'Sexe';
frenchLangs[LangIds.SUMMARY_GenderError] = 'Entrez votre sexe.';
frenchLangs[LangIds.SUMMARY_GivenNames] = 'Prénoms';
frenchLangs[LangIds.SUMMARY_GivenNamesError] = 'Entrez vos prénoms.';
frenchLangs[LangIds.SUMMARY_Surname] = 'Nom de famille';
frenchLangs[LangIds.SUMMARY_SurnameError] = 'Entrez votre nom de famille.';
frenchLangs[LangIds.SUMMARY_Fullname] = 'Nom complet';
frenchLangs[LangIds.SUMMARY_FullnameError] = 'Entrez votre nom complet.';
frenchLangs[LangIds.SUMMARY_Address] = 'Adresse';
frenchLangs[LangIds.SUMMARY_AddressError] = 'Entrez votre adresse.';
frenchLangs[LangIds.SUMMARY_DateOfBirth] = 'Date de naissance';
frenchLangs[LangIds.SUMMARY_DateOfBirthError] = 'Entrez votre date de naissance.';
frenchLangs[LangIds.SUMMARY_PersonalNumber] = 'Numéro personnel';
frenchLangs[LangIds.SUMMARY_PersonalNumberError] = 'Entrez votre numéro personnel.';
frenchLangs[LangIds.SUMMARY_Citizenship] = 'Citoyenneté';
frenchLangs[LangIds.SUMMARY_CitizenshipError] = 'Entrez votre citoyenneté.';
frenchLangs[LangIds.SUMMARY_Nationality] = 'Nationalité';
frenchLangs[LangIds.SUMMARY_NationalityError] = 'Entrez votre nationalité.';
frenchLangs[LangIds.SUMMARY_DocCountry] = 'Pays du document';
frenchLangs[LangIds.SUMMARY_DocCountryError] = 'Entrez le pays de votre document.';
frenchLangs[LangIds.SUMMARY_DocEdition] = 'Édition du document';
frenchLangs[LangIds.SUMMARY_DocEditionError] = 'Entrez l\'édition de votre document.';
frenchLangs[LangIds.SUMMARY_DocType] = 'Type de document';
frenchLangs[LangIds.SUMMARY_DocTypeError] = 'Entrez le type de votre document.';
frenchLangs[LangIds.SUMMARY_DocIssue] = 'Émission du document';
frenchLangs[LangIds.SUMMARY_DocIssueError] = 'Entrez l\'émission de votre document.';
frenchLangs[LangIds.SUMMARY_DocExpiry] = 'Expiration du document';
frenchLangs[LangIds.SUMMARY_DocExpiryError] = 'Entrez l\'expiration de votre document.';
frenchLangs[LangIds.SUMMARY_DocNumber] = 'Numéro du document';
frenchLangs[LangIds.SUMMARY_DocNumberError] = 'Entrez le numéro de votre document.';
frenchLangs[LangIds.SUMMARY_Retake] = 'Reprendre';

frenchLangs[LangIds.SERVER_Err] = 'Une erreur est survenue. Veuillez réessayer.';
frenchLangs[LangIds.SERVER_Err_front_fail] = 'La numérisation de votre document a échoué.';
frenchLangs[LangIds.SERVER_Err_front_fail_ext] = 'Veuillez numériser le CÔTÉ AVANT de votre carte d\'identité.';
frenchLangs[LangIds.SERVER_Err_front_exp] = 'Votre carte d\'identité est expirée';
frenchLangs[LangIds.SERVER_Err_front_exp_ext] = 'Vous ne pourrez pas continuer.';
frenchLangs[LangIds.SERVER_Err_front_change] = 'Désolé, il semble y avoir un problème avec votre carte d\'identité.';
frenchLangs[LangIds.SERVER_Err_front_change_ext] = 'Vous ne pourrez pas continuer.';
frenchLangs[LangIds.SERVER_Err_back_fail] = 'La numérisation de votre document a échoué.';
frenchLangs[LangIds.SERVER_Err_back_fail_ext] = 'Veuillez numériser le CÔTÉ ARRIÈRE de votre carte d\'identité.';
frenchLangs[LangIds.SERVER_Err_back_exp] = 'Votre carte d\'identité est expirée';
frenchLangs[LangIds.SERVER_Err_back_exp_ext] = 'Vous ne pourrez pas continuer.';
frenchLangs[LangIds.SERVER_Err_back_change] = 'Désolé, il semble y avoir un problème avec votre carte d\'identité.';
frenchLangs[LangIds.SERVER_Err_back_change_ext] = 'Vous ne pourrez pas continuer.';
frenchLangs[LangIds.SERVER_Err_face_in] = 'Votre visage est lié à un autre billet';
frenchLangs[LangIds.SERVER_Err_face_in_ext] = 'Recommencez avec un autre propriétaire de billet.';
frenchLangs[LangIds.SERVER_Err_face_liveness] = 'Échec de la vérification du visage';
frenchLangs[LangIds.SERVER_Err_face_liveness_ext] = 'Il semble que le selfie que vous avez pris n\'a pas une qualité suffisante.';
frenchLangs[LangIds.SERVER_Err_face_ban] = 'Vous n\'êtes pas autorisé à acheter des billets en raison de l\'interdiction de stade en cours';
frenchLangs[LangIds.SERVER_Err_face_ban_ext] = 'Recommencez avec un autre propriétaire de billet.';
frenchLangs[LangIds.SERVER_Err_face_spoof] = 'Échec de la vérification du visage';
frenchLangs[LangIds.SERVER_Err_face_spoof_ext] = 'Le visage de votre carte d\'identité ne correspond pas au selfie.';
frenchLangs[LangIds.SERVER_Err_child_in] = 'Votre visage est lié à un autre billet';
frenchLangs[LangIds.SERVER_Err_child_in_ext] = 'Recommencez avec un autre propriétaire de billet.';
frenchLangs[LangIds.SERVER_Err_child_liveness] = 'Échec de la vérification du visage';
frenchLangs[LangIds.SERVER_Err_child_liveness_ext] = 'Il semble que le selfie que vous avez pris n\'a pas une qualité suffisante.';
frenchLangs[LangIds.SERVER_Err_child_ban] = 'Vous n\'êtes pas autorisé à acheter des billets en raison de l\'interdiction de stade en cours';
frenchLangs[LangIds.SERVER_Err_child_ban_ext] = 'Recommencez avec un autre propriétaire de billet.';
frenchLangs[LangIds.SERVER_Err_child_spoof] = 'Échec de la vérification du visage';
frenchLangs[LangIds.SERVER_Err_child_spoof_ext] = 'Le visage de votre carte d\'identité ne correspond pas au selfie.';
frenchLangs[LangIds.SERVER_Err_child_old] = 'Il semble que vous avez plus de 15 ans';
frenchLangs[LangIds.SERVER_Err_child_old_ext] = 'Recommencez avec un autre propriétaire de billet.';
/*-----------------------------------FRENCH--------------------------------------*/

/*-----------------------------------DUTCH---------------------------------------*/
var dutchLangs: string[] = [];
dutchLangs[LangIds.BUTTON_Continue] = 'Ga verder';
dutchLangs[LangIds.LOGO_Powered] = 'AANGEBODEN DOOR';

dutchLangs[LangIds.TURN_Doc] = 'Draai de identiteitskaart om';

dutchLangs[LangIds.TIPS_Head1] = 'Tips voor het succesvol ';
dutchLangs[LangIds.TIPS_Head2] = 'capteren van het identiteitsdocument';
dutchLangs[LangIds.TIPS_Lightning1] = 'Zorg voor ';
dutchLangs[LangIds.TIPS_Lightning2] = 'goede lichtomstandigheden';
dutchLangs[LangIds.TIPS_Lightning3] = ' in de ruimte';
dutchLangs[LangIds.TIPS_Table1] = 'Leg het ';
dutchLangs[LangIds.TIPS_Table2] = 'identiteitsdocument op een tafel';
dutchLangs[LangIds.TIPS_Table3] = ' met een andere kleur wanneer u een foto neemt';
dutchLangs[LangIds.TIPS_reflections1] = 'Draai het document weg van het licht om ';
dutchLangs[LangIds.TIPS_reflections2] = 'reflecties op het document te voorkomen';
dutchLangs[LangIds.TIPS_reflections3] = ' ';

dutchLangs[LangIds.ACCEPT_ErrAccept] = 'U moet de condities en voorwaarden accepteren alvorens verder te gaan';
dutchLangs[LangIds.ACCEPT_Lets] = 'Laten we beginnen';
dutchLangs[LangIds.ACCEPT_First] = 'Je maakt eerst een foto van beide zijden van je geldige identiteitsdocument terwijl wij je gegevens inlezen, zodat je ze niet handmatig hoeft over te typen. Daarna neem je een selfie om de gelijkenis met de afbeelding van het document te controleren.';
dutchLangs[LangIds.ACCEPT_Terms1] = 'Ik ga akkoord met de ';
dutchLangs[LangIds.ACCEPT_Terms2] = 'Gebruiksvoorwaarden';
dutchLangs[LangIds.ACCEPT_Terms3] = ' en het ';
dutchLangs[LangIds.ACCEPT_Terms4] = 'Privacybeleid';
dutchLangs[LangIds.ACCEPT_Terms5] = ' voor het gebruik van FaceTicket. Ik geef mijn uitdrukkelijke toestemming voor het verwerken en opslaan van mijn persoonlijke gegevens om toegang te krijgen tot de locatie van de voetbalclub.';
dutchLangs[LangIds.ACCEPT_Sharing] = 'Ik ga akkoord met het delen van mijn gegevens voor het ontvangen van gepersonaliseerde communicatie van de organisatoren van het evenement.';

dutchLangs[LangIds.SELFIE_Header] = 'Neem een selfie';
dutchLangs[LangIds.SELFIE_Headnum] = '3/4';
dutchLangs[LangIds.SELFIE_Name] = 'Laten we een selfie nemen';
dutchLangs[LangIds.SELFIE_Desc1] = 'Houd uw telefoon verticaal';
dutchLangs[LangIds.SELFIE_Desc2] = ' en op ooghoogte wanneer u een foto van uw gezicht maakt.';
dutchLangs[LangIds.SELFIE_Take] = 'Neem een selfie';
dutchLangs[LangIds.SELFIE_Terms1] = 'Dávam výslovný súhlas so spracovaním a uchovávaním mojich osobných údajov na účely vstupu na miesto konania podujatia. Potvrdzujem, že som si prečítal, porozumel a súhlasím s ';
dutchLangs[LangIds.SELFIE_Terms2] = 'Podmienkami používania';

dutchLangs[LangIds.PROCESS_Processing] = 'Verwerken....';

dutchLangs[LangIds.ERROR_Retake] = 'Neem de selfie opnieuw';

dutchLangs[LangIds.MAIN_Selfie] = 'Neem een selfie’';
dutchLangs[LangIds.MAIN_Remove] = 'Verwijder klant uit het bestand';
dutchLangs[LangIds.MAIN_RemoveSucceeded] = 'Verwijderen geslaagd';
dutchLangs[LangIds.MAIN_RemoveSucceededText] = 'U heeft succesvol uw aankoop verwijderd';
dutchLangs[LangIds.MAIN_RemoveVisitor] = 'Verwijder  %VISITORNAME% en alle gelinkte tickets?';
dutchLangs[LangIds.MAIN_Capture] = 'Capteer ID';
dutchLangs[LangIds.MAIN_HeaderNum1] = '1/4';
dutchLangs[LangIds.MAIN_HeaderNum2] = '2/4';
dutchLangs[LangIds.MAIN_HeaderNum3] = '3/4';
dutchLangs[LangIds.MAIN_HeaderNum4] = '4/4';
dutchLangs[LangIds.MAIN_Child] = 'Kinderticket verificatie';
dutchLangs[LangIds.MAIN_ChildSucceeded] = 'Succesvolle verificatie';
dutchLangs[LangIds.MAIN_ChildSucceededText] = 'We hebben een bevestiging van uw ticket verstuurd naar uw e-mailadres.';
dutchLangs[LangIds.MAIN_Results] = 'Resultaat';
dutchLangs[LangIds.MAIN_ResultsSucceeded] = 'Succesvolle verificatie';
dutchLangs[LangIds.MAIN_ResultsSucceededText] = 'We hebben een bevestiging van uw ticket verstuurd naar uw e-mailadres';
dutchLangs[LangIds.MAIN_Retake] = 'Wilt u uw data opnieuw invullen?';
dutchLangs[LangIds.MAIN_Review] = 'Details';

dutchLangs[LangIds.SCANID_Capture] = 'Capteer ID';
dutchLangs[LangIds.SCANID_Front] = 'Voorzijde’';
dutchLangs[LangIds.SCANID_Back] = 'Achterzijde';
dutchLangs[LangIds.SCANID_candidate_selection] = 'Houd het document stil…';
dutchLangs[LangIds.SCANID_document_centering] = 'Plaats uw document in de rechthoek';
dutchLangs[LangIds.SCANID_document_not_present] = 'Plaats uw document in de rechthoek';
dutchLangs[LangIds.SCANID_document_too_far] = 'Kom dichter';
dutchLangs[LangIds.SCANID_sharpness_too_low] = 'Er is meer lichtinval nodig';
dutchLangs[LangIds.SCANID_brightness_too_low] = 'Er is meer lichtinval nodig';
dutchLangs[LangIds.SCANID_brightness_too_high] = 'Er is minder lichtinval nodig';
dutchLangs[LangIds.SCANID_hotspots_present] = 'Voorkom lichtreflecties op het document';
dutchLangs[LangIds.SCANID_loading] = 'Laden... Gelieve even te wachten.';
dutchLangs[LangIds.SCANID_waiting] = 'Verwerken... Gelieve even te wachten.';

dutchLangs[LangIds.SCANFACE_Selfie] = 'Neem een selfie';
dutchLangs[LangIds.SCANFACE_candidate_selection] = 'Houd stil…';
dutchLangs[LangIds.SCANFACE_face_too_close] = 'Ga een beetje achteruit';
dutchLangs[LangIds.SCANFACE_face_too_far] = 'Kom een beetje dichter’';
dutchLangs[LangIds.SCANFACE_face_centering] = 'Centreer uw gezicht';
dutchLangs[LangIds.SCANFACE_face_not_present] = 'Plaats uw gezicht in de cirkel';
dutchLangs[LangIds.SCANFACE_sharpness_too_low] = 'Draai uw gezicht naar het licht';
dutchLangs[LangIds.SCANFACE_brightness_too_low] = 'Draai uw gezicht naar het licht';
dutchLangs[LangIds.SCANFACE_brightness_too_high] = 'Minder lichtinval nodig';
dutchLangs[LangIds.SCANFACE_device_pitched] = 'Houd uw camera op ooghoogte';
dutchLangs[LangIds.SCANFACE_loading] = 'Laden... Gelieve even te wachten.';
dutchLangs[LangIds.SCANFACE_waiting] = 'Verwerken... Gelieve even te wachten.';

dutchLangs[LangIds.SUMMARY_Header] = 'Overzicht details';
dutchLangs[LangIds.SUMMARY_Headnum] = '2/4';
dutchLangs[LangIds.SUMMARY_Email] = 'E-mail';
dutchLangs[LangIds.SUMMARY_EmailError] = 'Uw e-mailadres is incorrect.';
dutchLangs[LangIds.SUMMARY_Age] = 'Leeftijd';
dutchLangs[LangIds.SUMMARY_AgeError] = 'Uw leeftijd is niet geldig.';
dutchLangs[LangIds.SUMMARY_Gender] = 'Geslacht';
dutchLangs[LangIds.SUMMARY_GenderError] = 'Vul uw geslacht in.';
dutchLangs[LangIds.SUMMARY_GivenNames] = 'Ingevulde namen’';
dutchLangs[LangIds.SUMMARY_GivenNamesError] = 'Vul uw namen in';
dutchLangs[LangIds.SUMMARY_Surname] = 'Achternaam';
dutchLangs[LangIds.SUMMARY_SurnameError] = 'Vul uw achternaam in';
dutchLangs[LangIds.SUMMARY_Fullname] = 'Volledige naam’';
dutchLangs[LangIds.SUMMARY_FullnameError] = 'Vul uw volledige naam in.';
dutchLangs[LangIds.SUMMARY_Address] = 'Adres';
dutchLangs[LangIds.SUMMARY_AddressError] = 'Vul uw adres in.';
dutchLangs[LangIds.SUMMARY_DateOfBirth] = 'Geboortedatum';
dutchLangs[LangIds.SUMMARY_DateOfBirthError] = 'Vul uw geboortedatum in.';
dutchLangs[LangIds.SUMMARY_PersonalNumber] = 'Persoonlijk nummer';
dutchLangs[LangIds.SUMMARY_PersonalNumberError] = 'Vul uw persoonlijk nummer in.';
dutchLangs[LangIds.SUMMARY_Citizenship] = 'Staat van burgerschap';
dutchLangs[LangIds.SUMMARY_CitizenshipError] = 'Vul uw staat van burgerschap in.';
dutchLangs[LangIds.SUMMARY_Nationality] = 'Nationaliteit';
dutchLangs[LangIds.SUMMARY_NationalityError] = 'Vul uw nationaliteit in.';
dutchLangs[LangIds.SUMMARY_DocCountry] = 'Land van het document’';
dutchLangs[LangIds.SUMMARY_DocCountryError] = 'Vul het land van uw document in.';
dutchLangs[LangIds.SUMMARY_DocEdition] = 'Document editie';
dutchLangs[LangIds.SUMMARY_DocEditionError] = 'Vul de editie van uw document in.';
dutchLangs[LangIds.SUMMARY_DocType] = 'Document type';
dutchLangs[LangIds.SUMMARY_DocTypeError] = 'Vul uw document type in.';
dutchLangs[LangIds.SUMMARY_DocIssue] = 'Document uitgifte';
dutchLangs[LangIds.SUMMARY_DocIssueError] = 'Vul de uitgifte van uw document in.';
dutchLangs[LangIds.SUMMARY_DocExpiry] = 'Vervaldatum document';
dutchLangs[LangIds.SUMMARY_DocExpiryError] = 'Vul de vervaldatum van uw document in.';
dutchLangs[LangIds.SUMMARY_DocNumber] = 'Document nummer';
dutchLangs[LangIds.SUMMARY_DocNumberError] = 'Vul uw documentnummer in.';
dutchLangs[LangIds.SUMMARY_Retake] = 'Neem opnieuw';

dutchLangs[LangIds.SERVER_Err] = 'Er ging iets verkeerd. Gelieve opnieuw te proberen.';
dutchLangs[LangIds.SERVER_Err_front_fail] = 'Het scannen van uw document is mislukt.';
dutchLangs[LangIds.SERVER_Err_front_fail_ext] = 'Gelieve de VOORKANT van uw ID in te scannen.';
dutchLangs[LangIds.SERVER_Err_front_exp] = 'Uw ID is vervallen.';
dutchLangs[LangIds.SERVER_Err_front_exp_ext] = 'U kan niet verder gaan.';
dutchLangs[LangIds.SERVER_Err_front_change] = 'Sorry, er blijkt een probleem te zijn met uw ID.';
dutchLangs[LangIds.SERVER_Err_front_change_ext] = 'U kan niet verder gaan.';
dutchLangs[LangIds.SERVER_Err_back_fail] = 'Het scannen van uw document is mislukt.';
dutchLangs[LangIds.SERVER_Err_back_fail_ext] = 'Gelieve de ACHTERKANT van uw ID in te scannen.';
dutchLangs[LangIds.SERVER_Err_back_exp] = 'Uw ID is vervallen.';
dutchLangs[LangIds.SERVER_Err_back_exp_ext] = 'U kan niet verder gaan.';
dutchLangs[LangIds.SERVER_Err_back_change] = 'Sorry, er blijkt een probleem te zijn met uw ID.';
dutchLangs[LangIds.SERVER_Err_back_change_ext] = 'U kan niet verder gaan.';
dutchLangs[LangIds.SERVER_Err_face_in] = 'Uw gezicht is gelinkt aan een ander ticket.';
dutchLangs[LangIds.SERVER_Err_face_in_ext] = 'Begin opnieuw met een andere eigenaar van het ticket';
dutchLangs[LangIds.SERVER_Err_face_liveness] = 'Verificatie van het gezicht mislukt';
dutchLangs[LangIds.SERVER_Err_face_liveness_ext] = 'De kwaliteit van de selfie was niet voldoende.';
dutchLangs[LangIds.SERVER_Err_face_ban] = 'U kan geen ticket aankopen door een lopend stadionverbod.';
dutchLangs[LangIds.SERVER_Err_face_ban_ext] = 'Begin opnieuw met een andere eigenaar van het ticket';
dutchLangs[LangIds.SERVER_Err_face_spoof] = 'Verificatie van het gezicht mislukt';
dutchLangs[LangIds.SERVER_Err_face_spoof_ext] = 'Uw selfie komt te weinig overeen met de pasfoto op uw ID.';
dutchLangs[LangIds.SERVER_Err_child_in] = 'Uw gezicht is gelinkt aan een ander ticket.';
dutchLangs[LangIds.SERVER_Err_child_in_ext] = 'Begin opnieuw met een andere eigenaar van het ticket.';
dutchLangs[LangIds.SERVER_Err_child_liveness] = 'Verificatie van het gezicht mislukt';
dutchLangs[LangIds.SERVER_Err_child_liveness_ext] = 'Uw selfie komt te weinig overeen met de pasfoto op uw ID.';
dutchLangs[LangIds.SERVER_Err_child_ban] = 'U kan geen ticket aankopen door een lopend stadionverbod.';
dutchLangs[LangIds.SERVER_Err_child_ban_ext] = 'Begin opnieuw met een andere eigenaar van het ticket.';
dutchLangs[LangIds.SERVER_Err_child_spoof] = 'Verificatie van het gezicht mislukt';
dutchLangs[LangIds.SERVER_Err_child_spoof_ext] = 'Uw selfie komt te weinig overeen met de pasfoto op uw ID.';
dutchLangs[LangIds.SERVER_Err_child_old] = 'U bent te oud voor dit ticket';
dutchLangs[LangIds.SERVER_Err_child_old_ext] = 'Begin opnieuw met een andere eigenaar van het ticket.';
/*-----------------------------------DUTCH---------------------------------------*/

/*-----------------------------------GERMAN--------------------------------------*/
var germanLangs: string[] = [];
germanLangs[LangIds.BUTTON_Continue] = 'Weiter';
germanLangs[LangIds.LOGO_Powered] = 'POWERED BY';

germanLangs[LangIds.TURN_Doc] = 'Dokumentenkarte auf die Rückseite drehen';

germanLangs[LangIds.TIPS_Head1] = 'Tipps für eine erfolgreiche ';
germanLangs[LangIds.TIPS_Head2] = 'Dokumentenerfassung';
germanLangs[LangIds.TIPS_Lightning1] = 'Sorgen Sie für ';
germanLangs[LangIds.TIPS_Lightning2] = 'gute Lichtverhältnisse';
germanLangs[LangIds.TIPS_Lightning3] = ' im Raum';
germanLangs[LangIds.TIPS_Table1] = 'Legen Sie das ';
germanLangs[LangIds.TIPS_Table2] = 'Ausweisdokument auf einen Tisch';
germanLangs[LangIds.TIPS_Table3] = ' mit einer anderen Hintergrundfarbe.';
germanLangs[LangIds.TIPS_reflections1] = 'Um ';
germanLangs[LangIds.TIPS_reflections2] = 'Reflexionen auf dem Dokument zu vermeiden,';
germanLangs[LangIds.TIPS_reflections3] = ' drehen Sie es vom Licht weg.';

germanLangs[LangIds.ACCEPT_ErrAccept] = 'Sie müssen die Bedingungen akzeptieren, um fortzufahren.';
germanLangs[LangIds.ACCEPT_Lets] = 'Los geht\'s';
germanLangs[LangIds.ACCEPT_First] = 'Erst fotografieren Sie beide Seiten Ihres gültigen Ausweises, während wir Ihre Daten extrahieren. So dass Sie sie nicht manuell eingeben müssen. Danach machen Sie ein Selfie, das mit dem Bild des Dokuments übereinstimmt.';
germanLangs[LangIds.ACCEPT_Terms1] = 'Ich akzeptiere die ';
germanLangs[LangIds.ACCEPT_Terms2] = 'Nutzungsbedingungen';
germanLangs[LangIds.ACCEPT_Terms3] = ' und ';
germanLangs[LangIds.ACCEPT_Terms4] = 'Datenschutzrichtlinien';
germanLangs[LangIds.ACCEPT_Terms5] = ' für die Nutzung von FaceTicket. Ich gebe meine ausdrückliche Zustimmung zur Verarbeitung und Speicherung meiner persönlichen Daten zum Zwecke des Zutritts zum Veranstaltungsort.';
germanLangs[LangIds.ACCEPT_Sharing] = 'Ich akzeptiere die Weitergabe meiner Daten, um personalisierte Kommunikation von den Veranstaltern zu erhalten.';

germanLangs[LangIds.SELFIE_Header] = 'Machen Sie ein Selfie';
germanLangs[LangIds.SELFIE_Headnum] = '3/4';
germanLangs[LangIds.SELFIE_Name] = 'Lassen Sie uns ein Selfie machen';
germanLangs[LangIds.SELFIE_Desc1] = 'Halten Sie Ihr Telefon senkrecht';
germanLangs[LangIds.SELFIE_Desc2] = ' und auf Augenhöhe.';
germanLangs[LangIds.SELFIE_Take] = 'Machen Sie ein Selfie';
germanLangs[LangIds.SELFIE_Terms1] = 'Dávam výslovný súhlas so spracovaním a uchovávaním mojich osobných údajov na účely vstupu na miesto konania podujatia. Potvrdzujem, že som si prečítal, porozumel a súhlasím s ';
germanLangs[LangIds.SELFIE_Terms2] = 'Podmienkami používania';

germanLangs[LangIds.PROCESS_Processing] = 'Wird bearbeitet....';

germanLangs[LangIds.ERROR_Retake] = 'Erneut aufnehmen';

germanLangs[LangIds.MAIN_Selfie] = 'Machen Sie ein Selfie';
germanLangs[LangIds.MAIN_Remove] = 'Kunden entfernen';
germanLangs[LangIds.MAIN_RemoveSucceeded] = 'Entfernung erfolgreich';
germanLangs[LangIds.MAIN_RemoveSucceededText] = 'Sie haben Ihren Kauf erfolgreich gelöscht.';
germanLangs[LangIds.MAIN_RemoveVisitor] = 'Kunden %VISITORNAME% einschließlich aller Tickets entfernen?';
germanLangs[LangIds.MAIN_Capture] = 'ID erfassen';
germanLangs[LangIds.MAIN_HeaderNum1] = '1/4';
germanLangs[LangIds.MAIN_HeaderNum2] = '2/4';
germanLangs[LangIds.MAIN_HeaderNum3] = '3/4';
germanLangs[LangIds.MAIN_HeaderNum4] = '4/4';
germanLangs[LangIds.MAIN_Child] = 'Kinderticket-Überprüfung';
germanLangs[LangIds.MAIN_ChildSucceeded] = 'Verifizierung erfolgreich';
germanLangs[LangIds.MAIN_ChildSucceededText] = 'Wir haben Ihnen eine Ticketbestätigung an Ihre E-Mail gesendet.';
germanLangs[LangIds.MAIN_Results] = 'Ergebnisse';
germanLangs[LangIds.MAIN_ResultsSucceeded] = 'Verifizierung erfolgreich';
germanLangs[LangIds.MAIN_ResultsSucceededText] = 'Wir haben Ihnen eine Ticketbestätigung an Ihre E-Mail gesendet.';
germanLangs[LangIds.MAIN_Retake] = 'Möchten Sie wirklich Ihre Daten erneut aufnehmen?';
germanLangs[LangIds.MAIN_Review] = 'Details überprüfen';

germanLangs[LangIds.SCANID_Capture] = 'ID erfassen';
germanLangs[LangIds.SCANID_Front] = 'Vorderseite';
germanLangs[LangIds.SCANID_Back] = 'Rückseite';
germanLangs[LangIds.SCANID_candidate_selection] = 'Stillhalten…';
germanLangs[LangIds.SCANID_document_centering] = 'Dokument in das Rechteck bewegen';
germanLangs[LangIds.SCANID_document_not_present] = 'Dokument in das Rechteck bewegen';
germanLangs[LangIds.SCANID_document_too_far] = 'Näher heranrücken';
germanLangs[LangIds.SCANID_sharpness_too_low] = 'Mehr Licht nötig';
germanLangs[LangIds.SCANID_brightness_too_low] = 'Mehr Licht nötig';
germanLangs[LangIds.SCANID_brightness_too_high] = 'Weniger Licht nötig';
germanLangs[LangIds.SCANID_hotspots_present] = 'Reflektionen vermeiden';
germanLangs[LangIds.SCANID_loading] = 'Laden. Bitte warten.';
germanLangs[LangIds.SCANID_waiting] = 'Verarbeitung. Bitte warten.';

germanLangs[LangIds.SCANFACE_Selfie] = 'Machen Sie ein Selfie';
germanLangs[LangIds.SCANFACE_candidate_selection] = 'Stillhalten…';
germanLangs[LangIds.SCANFACE_face_too_close] = 'Zurückgehen';
germanLangs[LangIds.SCANFACE_face_too_far] = 'Näher heranrücken';
germanLangs[LangIds.SCANFACE_face_centering] = 'Gesicht zentrieren';
germanLangs[LangIds.SCANFACE_face_not_present] = 'Positionieren Sie Ihr Gesicht im Kreis';
germanLangs[LangIds.SCANFACE_sharpness_too_low] = 'Gesicht ins Licht drehen';
germanLangs[LangIds.SCANFACE_brightness_too_low] = 'Gesicht ins Licht drehen';
germanLangs[LangIds.SCANFACE_brightness_too_high] = 'Weniger Licht nötig';
germanLangs[LangIds.SCANFACE_device_pitched] = 'Halten Sie Ihr Telefon auf Augenhöhe';
germanLangs[LangIds.SCANFACE_loading] = 'Laden. Bitte warten.';
germanLangs[LangIds.SCANFACE_waiting] = 'Verarbeitung. Bitte warten.';

germanLangs[LangIds.SUMMARY_Header] = 'Details überprüfen';
germanLangs[LangIds.SUMMARY_Headnum] = '2/4';
germanLangs[LangIds.SUMMARY_Email] = 'E-Mail';
germanLangs[LangIds.SUMMARY_EmailError] = 'Ihre E-Mail-Adresse ist nicht gültig.';
germanLangs[LangIds.SUMMARY_Age] = 'Alter';
germanLangs[LangIds.SUMMARY_AgeError] = 'Ihr Alter ist keine gültige Zahl.';
germanLangs[LangIds.SUMMARY_Gender] = 'Geschlecht';
germanLangs[LangIds.SUMMARY_GenderError] = 'Geben Sie Ihr Geschlecht ein.';
germanLangs[LangIds.SUMMARY_GivenNames] = 'Vornamen';
germanLangs[LangIds.SUMMARY_GivenNamesError] = 'Geben Sie Ihre Vornamen ein.';
germanLangs[LangIds.SUMMARY_Surname] = 'Nachname';
germanLangs[LangIds.SUMMARY_SurnameError] = 'Geben Sie Ihren Nachnamen ein.';
germanLangs[LangIds.SUMMARY_Fullname] = 'Vollständiger Name';
germanLangs[LangIds.SUMMARY_FullnameError] = 'Geben Sie Ihren vollständigen Namen ein.';
germanLangs[LangIds.SUMMARY_Address] = 'Adresse';
germanLangs[LangIds.SUMMARY_AddressError] = 'Geben Sie Ihre Adresse ein.';
germanLangs[LangIds.SUMMARY_DateOfBirth] = 'Geburtsdatum';
germanLangs[LangIds.SUMMARY_DateOfBirthError] = 'Geben Sie Ihr Geburtsdatum ein.';
germanLangs[LangIds.SUMMARY_PersonalNumber] = 'Identifikationsnummer ';
germanLangs[LangIds.SUMMARY_PersonalNumberError] = 'Geben Sie Ihre Identifikationsnummer ein.';
germanLangs[LangIds.SUMMARY_Citizenship] = 'Staatsbürgerschaft';
germanLangs[LangIds.SUMMARY_CitizenshipError] = 'Geben Sie Ihre Staatsbürgerschaft ein.';
germanLangs[LangIds.SUMMARY_Nationality] = 'Nationalität';
germanLangs[LangIds.SUMMARY_NationalityError] = 'Geben Sie Ihre Nationalität ein.';
germanLangs[LangIds.SUMMARY_DocCountry] = 'Ausstellungsland des Dokuments';
germanLangs[LangIds.SUMMARY_DocCountryError] = 'Geben Sie das Ausstellungsland Ihres Dokuments ein.';
germanLangs[LangIds.SUMMARY_DocEdition] = 'Dokumentenversion';
germanLangs[LangIds.SUMMARY_DocEditionError] = 'Geben Sie die Version Ihres Dokuments an.'; 
germanLangs[LangIds.SUMMARY_DocType] = 'Dokumententyp';
germanLangs[LangIds.SUMMARY_DocTypeError] = 'Geben Sie Ihren Dokumententyp ein.';
germanLangs[LangIds.SUMMARY_DocIssue] = 'Dokumentenversion';
germanLangs[LangIds.SUMMARY_DocIssueError] = 'Geben Sie die Version Ihres Dokuments ein.'; 
germanLangs[LangIds.SUMMARY_DocExpiry] = 'Ablaufdatum';
germanLangs[LangIds.SUMMARY_DocExpiryError] = 'Geben Sie das Ablaufdatum Ihres Dokuments ein.';
germanLangs[LangIds.SUMMARY_DocNumber] = 'Dokumentennummer';
germanLangs[LangIds.SUMMARY_DocNumberError] = 'Geben Sie Ihre Dokumentennummer ein.';
germanLangs[LangIds.SUMMARY_Retake] = 'Erneut eingeben';

germanLangs[LangIds.SERVER_Err] = 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.';
germanLangs[LangIds.SERVER_Err_front_fail] = 'Ihr Dokumentenscan ist fehlgeschlagen.';
germanLangs[LangIds.SERVER_Err_front_fail_ext] = 'Bitte scannen Sie die VORDERSEITE Ihres Ausweises.';
germanLangs[LangIds.SERVER_Err_front_exp] = 'Ihr Ausweis ist abgelaufen';
germanLangs[LangIds.SERVER_Err_front_exp_ext] = 'Sie können nicht fortfahren.';
germanLangs[LangIds.SERVER_Err_front_change] = 'Entschuldigung, es scheint ein Problem mit Ihrem Ausweis zu geben.';
germanLangs[LangIds.SERVER_Err_front_change_ext] = 'Sie können nicht fortfahren.';
germanLangs[LangIds.SERVER_Err_back_fail] = 'Ihr Dokumentenscan ist fehlgeschlagen.';
germanLangs[LangIds.SERVER_Err_back_fail_ext] = 'Bitte scannen Sie die RÜCKSEITE Ihres Ausweises.';
germanLangs[LangIds.SERVER_Err_back_exp] = 'Ihr Ausweis ist abgelaufen';
germanLangs[LangIds.SERVER_Err_back_exp_ext] = 'Sie können nicht fortfahren.';
germanLangs[LangIds.SERVER_Err_back_change] = 'Entschuldigung, es scheint ein Problem mit Ihrem Ausweis zu geben.';
germanLangs[LangIds.SERVER_Err_back_change_ext] = 'Sie können nicht fortfahren.';
germanLangs[LangIds.SERVER_Err_face_in] = 'Ihr Gesicht ist mit einem anderen Ticket verknüpft';
germanLangs[LangIds.SERVER_Err_face_in_ext] = 'Beginnen Sie von vorne mit einem anderen Ticketinhaber.';
germanLangs[LangIds.SERVER_Err_face_liveness] = 'Gesichtsverifizierung fehlgeschlagen';
germanLangs[LangIds.SERVER_Err_face_liveness_ext] = 'Es scheint, dass das Selfie, das Sie gemacht haben, nicht von ausreichender Qualität ist.';
germanLangs[LangIds.SERVER_Err_face_ban] = 'Sie dürfen aufgrund des laufenden Stadionverbots keine Tickets kaufen';
germanLangs[LangIds.SERVER_Err_face_ban_ext] = 'Beginnen Sie von vorne mit einem anderen Ticketinhaber.';
germanLangs[LangIds.SERVER_Err_face_spoof] = 'Gesichtsverifizierung fehlgeschlagen';
germanLangs[LangIds.SERVER_Err_face_spoof_ext] = 'Das Gesicht auf Ihrem Ausweis stimmt nicht mit dem Selfie überein.';
germanLangs[LangIds.SERVER_Err_child_in] = 'Ihr Gesicht ist mit einem anderen Ticket verknüpft';
germanLangs[LangIds.SERVER_Err_child_in_ext] = 'Beginnen Sie von vorne mit einem anderen Ticketinhaber.';
germanLangs[LangIds.SERVER_Err_child_liveness] = 'Gesichtsverifizierung fehlgeschlagen';
germanLangs[LangIds.SERVER_Err_child_liveness_ext] = 'Es scheint, dass das Selfie, das Sie gemacht haben, nicht von ausreichender Qualität ist.';
germanLangs[LangIds.SERVER_Err_child_ban] = 'Sie dürfen aufgrund des laufenden Stadionverbots keine Tickets kaufen';
germanLangs[LangIds.SERVER_Err_child_ban_ext] = 'Beginnen Sie von vorne mit einem anderen Ticketinhaber.';
germanLangs[LangIds.SERVER_Err_child_spoof] = 'Gesichtsverifizierung fehlgeschlagen';
germanLangs[LangIds.SERVER_Err_child_spoof_ext] = 'Das Gesicht auf Ihrem Ausweis stimmt nicht mit dem Selfie überein.';
germanLangs[LangIds.SERVER_Err_child_old] = 'Es sieht so aus, als wären Sie über 15 Jahre alt';
germanLangs[LangIds.SERVER_Err_child_old_ext] = 'Beginnen Sie von vorne mit einem anderen Ticketinhaber.';
/*-----------------------------------GERMAN--------------------------------------*/

/*-----------------------------------SLOVAK--------------------------------------*/
var slovakLangs: string[] = [];
slovakLangs[LangIds.BUTTON_Continue] = 'Pokračovať';
slovakLangs[LangIds.LOGO_Powered] = 'POWERED BY';

slovakLangs[LangIds.TURN_Doc] = 'Otočte preukaz totožnosti na zadnú stranu';

slovakLangs[LangIds.TIPS_Head1] = 'Tips for successful ';
slovakLangs[LangIds.TIPS_Head2] = 'document capture';
slovakLangs[LangIds.TIPS_Lightning1] = 'Uistite sa, že máte v miestnosti ';
slovakLangs[LangIds.TIPS_Lightning2] = 'dobré svetelné podmienky';
slovakLangs[LangIds.TIPS_Lightning3] = ' ';
slovakLangs[LangIds.TIPS_Table1] = 'Pri fotografovaní položte ';
slovakLangs[LangIds.TIPS_Table2] = 'preukaz totožnosti na stôl';
slovakLangs[LangIds.TIPS_Table3] = ' s inou farbou';
slovakLangs[LangIds.TIPS_reflections1] = 'Aby ste ';
slovakLangs[LangIds.TIPS_reflections2] = 'zabránili odrazom na doklade,';
slovakLangs[LangIds.TIPS_reflections3] = ' otočte ho smerom od svetla';

slovakLangs[LangIds.ACCEPT_ErrAccept] = 'Ak chcete pokračovať, musíte prijať podmienky.';
slovakLangs[LangIds.ACCEPT_Lets] = 'Poďme na to';
slovakLangs[LangIds.ACCEPT_First] = 'Najprv nasnímate obe strany platného preukazu totožnosti, zatiaľ čo vám vyextrahujeme údaje, aby ste ich nemuseli zadávať manuálne. Potom si urobíte selfie, ktoré sa bude porovnávať s fotografiou na preukaze.';
slovakLangs[LangIds.ACCEPT_Terms1] = 'Súhlasím s ';
slovakLangs[LangIds.ACCEPT_Terms2] = 'Podmienkami používania';
slovakLangs[LangIds.ACCEPT_Terms3] = ' a ';
slovakLangs[LangIds.ACCEPT_Terms4] = 'Pravidlami ochrany osobných údajov';
slovakLangs[LangIds.ACCEPT_Terms5] = ' pri používaní služby FaceTicket. Dávam výslovný súhlas so spracovaním a uchovávaním mojich osobných údajov na účely vstupu na miesto konania podujatia.';
slovakLangs[LangIds.ACCEPT_Sharing] = 'Súhlasím so zdieľaním svojich údajov na účely prijímania personalizovanej komunikácie od organizátorov podujatia.';

slovakLangs[LangIds.SELFIE_Header] = 'Odfoťte sa';
slovakLangs[LangIds.SELFIE_Headnum] = '3/4';
slovakLangs[LangIds.SELFIE_Name] = 'Urobte si selfie';
slovakLangs[LangIds.SELFIE_Desc1] = 'Pri fotografovaní tváre';
slovakLangs[LangIds.SELFIE_Desc2] = ' držte telefón vo zvislej polohe na úrovni očí';
slovakLangs[LangIds.SELFIE_Take] = 'Odfoťte sa';
slovakLangs[LangIds.SELFIE_Terms1] = 'Dávam výslovný súhlas so spracovaním a uchovávaním mojich osobných údajov na účely vstupu na miesto konania podujatia. Potvrdzujem, že som si prečítal, porozumel a súhlasím s ';
slovakLangs[LangIds.SELFIE_Terms2] = 'Podmienkami používania';

slovakLangs[LangIds.PROCESS_Processing] = 'Spracováva sa....';

slovakLangs[LangIds.ERROR_Retake] = 'Zopakovať';

slovakLangs[LangIds.MAIN_Selfie] = 'Odfoťte sa';
slovakLangs[LangIds.MAIN_Remove] = 'Odstrániť zákazníka';
slovakLangs[LangIds.MAIN_RemoveSucceeded] = 'Odstránenie bolo úspešné';
slovakLangs[LangIds.MAIN_RemoveSucceededText] = 'Úspešne ste odstránili svoj nákup.';
slovakLangs[LangIds.MAIN_RemoveVisitor] = 'Odstrániť zákazníka %VISITORNAME% vrátane zakúpených lístkov?';
slovakLangs[LangIds.MAIN_Capture] = 'Odfoťte doklad';
slovakLangs[LangIds.MAIN_HeaderNum1] = '1/4';
slovakLangs[LangIds.MAIN_HeaderNum2] = '2/4';
slovakLangs[LangIds.MAIN_HeaderNum3] = '3/4';
slovakLangs[LangIds.MAIN_HeaderNum4] = '4/4';
slovakLangs[LangIds.MAIN_Child] = 'Overenie detského lístka';
slovakLangs[LangIds.MAIN_ChildSucceeded] = 'Overenie bolo úspešné';
slovakLangs[LangIds.MAIN_ChildSucceededText] = 'Potvrdenie lístka sme vám poslali na váš e-mail.';
slovakLangs[LangIds.MAIN_Results] = 'Výsledky';
slovakLangs[LangIds.MAIN_ResultsSucceeded] = 'Overenie bolo úspešné';
slovakLangs[LangIds.MAIN_ResultsSucceededText] = 'Potvrdenie lístka sme vám poslali na váš e-mail.';
slovakLangs[LangIds.MAIN_Retake] = 'Naozaj chcete zopakovať zadávanie údajov?';
slovakLangs[LangIds.MAIN_Review] = 'Skontrolujte údaje';

slovakLangs[LangIds.SCANID_Capture] = 'Odfoťte doklad';
slovakLangs[LangIds.SCANID_Front] = 'Predná strana';
slovakLangs[LangIds.SCANID_Back] = 'Zadná strana';
slovakLangs[LangIds.SCANID_candidate_selection] = 'Nehýbať…';
slovakLangs[LangIds.SCANID_document_centering] = 'Umiestnite dokument do obdĺžnika';
slovakLangs[LangIds.SCANID_document_not_present] = 'Umiestnite dokument do obdĺžnika';
slovakLangs[LangIds.SCANID_document_too_far] = 'Bližšie';
slovakLangs[LangIds.SCANID_sharpness_too_low] = 'Viac svetla';
slovakLangs[LangIds.SCANID_brightness_too_low] = 'Viac svetla';
slovakLangs[LangIds.SCANID_brightness_too_high] = 'Menej svetla';
slovakLangs[LangIds.SCANID_hotspots_present] = 'Vyhnite sa odleskom';
slovakLangs[LangIds.SCANID_loading] = 'Načítava sa. Prosím čakajte.';
slovakLangs[LangIds.SCANID_waiting] = 'Spracováva sa. Prosím čakajte.';

slovakLangs[LangIds.SCANFACE_Selfie] = 'Odfoťte sa';
slovakLangs[LangIds.SCANFACE_candidate_selection] = 'Nehýbte sa…';
slovakLangs[LangIds.SCANFACE_face_too_close] = 'Trochu vzad';
slovakLangs[LangIds.SCANFACE_face_too_far] = 'Trochu bližšie';
slovakLangs[LangIds.SCANFACE_face_centering] = 'Vycentrujte tvár';
slovakLangs[LangIds.SCANFACE_face_not_present] = 'Umiestnite svoju tvár do kruhu';
slovakLangs[LangIds.SCANFACE_sharpness_too_low] = 'Otočte tvár proti svetlu';
slovakLangs[LangIds.SCANFACE_brightness_too_low] = 'Otočte tvár proti svetlu';
slovakLangs[LangIds.SCANFACE_brightness_too_high] = 'Menej svetla';
slovakLangs[LangIds.SCANFACE_device_pitched] = 'Držte telefón vo výške očí';
slovakLangs[LangIds.SCANFACE_loading] = 'Načítava sa. Prosím čakajte.';
slovakLangs[LangIds.SCANFACE_waiting] = 'Spracováva sa. Prosím čakajte.';

slovakLangs[LangIds.SUMMARY_Header] = 'Skontrolujte údaje';
slovakLangs[LangIds.SUMMARY_Headnum] = '2/4';
slovakLangs[LangIds.SUMMARY_Email] = 'Email';
slovakLangs[LangIds.SUMMARY_EmailError] = 'Vaša e-mailová adresa nie je platná.';
slovakLangs[LangIds.SUMMARY_Age] = 'Vek';
slovakLangs[LangIds.SUMMARY_AgeError] = 'Váš vek nie je platné číslo.';
slovakLangs[LangIds.SUMMARY_Gender] = 'Pohlavie';
slovakLangs[LangIds.SUMMARY_GenderError] = 'Zadajte svoje pohlavie.';
slovakLangs[LangIds.SUMMARY_GivenNames] = 'Krstné meno';
slovakLangs[LangIds.SUMMARY_GivenNamesError] = 'Zadajte svoje krstné meno.';
slovakLangs[LangIds.SUMMARY_Surname] = 'Priezvisko';
slovakLangs[LangIds.SUMMARY_SurnameError] = 'Zadajte svoje priezvisko.';
slovakLangs[LangIds.SUMMARY_Fullname] = 'Celé meno';
slovakLangs[LangIds.SUMMARY_FullnameError] = 'Zadajte svoje celé meno.';
slovakLangs[LangIds.SUMMARY_Address] = 'Adresa';
slovakLangs[LangIds.SUMMARY_AddressError] = 'Zadajte svoju adresu.';
slovakLangs[LangIds.SUMMARY_DateOfBirth] = 'Dátum narodenia';
slovakLangs[LangIds.SUMMARY_DateOfBirthError] = 'Zadajte dátum narodenia.';
slovakLangs[LangIds.SUMMARY_PersonalNumber] = 'Rodné číslo';
slovakLangs[LangIds.SUMMARY_PersonalNumberError] = 'Zadajte rodné číslo.';
slovakLangs[LangIds.SUMMARY_Citizenship] = 'Občianstvo';
slovakLangs[LangIds.SUMMARY_CitizenshipError] = 'Zadajte občianstvo.';
slovakLangs[LangIds.SUMMARY_Nationality] = 'Národnosť';
slovakLangs[LangIds.SUMMARY_NationalityError] = 'Zadajte národnosť.';
slovakLangs[LangIds.SUMMARY_DocCountry] = 'Krajina pôvodu dokladu';
slovakLangs[LangIds.SUMMARY_DocCountryError] = 'Zadajte krajinu pôvodu dokladu.';
slovakLangs[LangIds.SUMMARY_DocEdition] = 'Edícia dokladu';
slovakLangs[LangIds.SUMMARY_DocEditionError] = 'Zadajte edíciu dokladu.';
slovakLangs[LangIds.SUMMARY_DocType] = 'Typ dokladu';
slovakLangs[LangIds.SUMMARY_DocTypeError] = 'Zadajte typ dokladu';
slovakLangs[LangIds.SUMMARY_DocIssue] = 'Dátum vydania dokladu';
slovakLangs[LangIds.SUMMARY_DocIssueError] = 'Zadajte dátum vydania dokladu.';
slovakLangs[LangIds.SUMMARY_DocExpiry] = 'Platnosť dokladu';
slovakLangs[LangIds.SUMMARY_DocExpiryError] = 'Zadajte dátum platnosti dokladu.';
slovakLangs[LangIds.SUMMARY_DocNumber] = 'Číslo dokladu';
slovakLangs[LangIds.SUMMARY_DocNumberError] = 'Zadajte číslo dokladu.';
slovakLangs[LangIds.SUMMARY_Retake] = 'Zopakovať';

slovakLangs[LangIds.SERVER_Err] = 'Niečo sa pokazilo. Prosím skúste znova.';
slovakLangs[LangIds.SERVER_Err_front_fail] = 'Skenovanie Vášho dokladu zlyhalo.';
slovakLangs[LangIds.SERVER_Err_front_fail_ext] = 'Naskenujte, prosím, PREDNÚ STRANU svojho dokladu.';
slovakLangs[LangIds.SERVER_Err_front_exp] = 'Platnosť vášho dokladu vypršala';
slovakLangs[LangIds.SERVER_Err_front_exp_ext] = 'Nebudete môcť pokračovať.';
slovakLangs[LangIds.SERVER_Err_front_change] = 'Ľutujeme, zdá sa, že sa vyskytol problém s Vaším dokladom.';
slovakLangs[LangIds.SERVER_Err_front_change_ext] = 'Nebudete môcť pokračovať.';
slovakLangs[LangIds.SERVER_Err_back_fail] = 'Skenovanie Vášho dokladu zlyhalo.';
slovakLangs[LangIds.SERVER_Err_back_fail_ext] = 'Naskenujte, prosím, ZADNÚ STRANU svojho dokladu.';
slovakLangs[LangIds.SERVER_Err_back_exp] = 'Platnosť vášho dokladu vypršala';
slovakLangs[LangIds.SERVER_Err_back_exp_ext] = 'Nebudete môcť pokračovať.';
slovakLangs[LangIds.SERVER_Err_back_change] = 'Ľutujeme, zdá sa, že sa vyskytol problém s Vaším dokladom.';
slovakLangs[LangIds.SERVER_Err_back_change_ext] = 'Nebudete môcť pokračovať.';
slovakLangs[LangIds.SERVER_Err_face_in] = 'Vaša tvár je prepojená s iným tiketom';
slovakLangs[LangIds.SERVER_Err_face_in_ext] = 'Začnite odznova s iným vlastníkom lístka.';
slovakLangs[LangIds.SERVER_Err_face_liveness] = 'Overenie tváre zlyhalo';
slovakLangs[LangIds.SERVER_Err_face_liveness_ext] = 'Zdá sa, že selfie, ktorú ste urobili, nemá dostatočnú kvalitu.';
slovakLangs[LangIds.SERVER_Err_face_ban] = 'Vstupenky nie je možné zakúpiť z dôvodu zákazu vstupu na štadión';
slovakLangs[LangIds.SERVER_Err_face_ban_ext] = 'Začnite odznova s iným vlastníkom lístka.';
slovakLangs[LangIds.SERVER_Err_face_spoof] = 'Overenie tváre zlyhalo';
slovakLangs[LangIds.SERVER_Err_face_spoof_ext] = 'Tvár z vášho dokladu sa nezhoduje so selfie.';
slovakLangs[LangIds.SERVER_Err_child_in] = 'Vaša tvár je prepojená s iným tiketom';
slovakLangs[LangIds.SERVER_Err_child_in_ext] = 'Začnite odznova s iným vlastníkom lístka.';
slovakLangs[LangIds.SERVER_Err_child_liveness] = 'Overenie tváre zlyhalo';
slovakLangs[LangIds.SERVER_Err_child_liveness_ext] = 'Zdá sa, že selfie, ktorú ste urobili, nemá dostatočnú kvalitu.';
slovakLangs[LangIds.SERVER_Err_child_ban] = 'Vstupenky nie je možné zakúpiť z dôvodu zákazu vstupu na štadión';
slovakLangs[LangIds.SERVER_Err_child_ban_ext] = 'Začnite odznova s iným vlastníkom lístka.';
slovakLangs[LangIds.SERVER_Err_child_spoof] = 'Overenie tváre zlyhalo';
slovakLangs[LangIds.SERVER_Err_child_spoof_ext] = 'Tvár z vášho dokladu sa nezhoduje so selfie.';
slovakLangs[LangIds.SERVER_Err_child_old] = 'Zdá sa, že máte viac ako 15 rokov';
slovakLangs[LangIds.SERVER_Err_child_old_ext] = 'Začnite odznova s iným vlastníkom lístka.';
/*-----------------------------------SLOVAK--------------------------------------*/

/*-----------------------------------BRAZIL--------------------------------------*/
var brazilLangs: string[] = [];
brazilLangs[LangIds.BUTTON_Continue] = 'Próximo';
brazilLangs[LangIds.LOGO_Powered] = 'HABILITADO POR';

brazilLangs[LangIds.TURN_Doc] = 'Vire o documento para o lado de trás';

brazilLangs[LangIds.TIPS_Head1] = 'Dicas para êxito ';
brazilLangs[LangIds.TIPS_Head2] = 'documento capturado';
brazilLangs[LangIds.TIPS_Lightning1] =  'Tenha certeza de que você tenha'
brazilLangs[LangIds.TIPS_Lightning2] = 'boas condições de iluminação';
brazilLangs[LangIds.TIPS_Lightning3] = ' no ambiente ';
brazilLangs[LangIds.TIPS_Table1] = 'Coloque o ';
brazilLangs[LangIds.TIPS_Table2] = 'documento em uma mesa';
brazilLangs[LangIds.TIPS_Table3] = ' com uma cor diferente ao tirar uma foto';
brazilLangs[LangIds.TIPS_reflections1] = 'Para ';
brazilLangs[LangIds.TIPS_reflections2] = 'evitar reflexos';
brazilLangs[LangIds.TIPS_reflections3] = ' no documento, vire-o de costas para a luz';

brazilLangs[LangIds.ACCEPT_ErrAccept] = 'Você deve aceitar os termos e condições para continuar.';
brazilLangs[LangIds.ACCEPT_Lets] = 'Vamos começar';
brazilLangs[LangIds.ACCEPT_First] = 'Primeiro, você capturará os dois lados do seu documento de identidade válido, enquanto extraímos seus dados para que você não precise digitá-los manualmente. Em seguida, você tirará uma selfie para comparar com a imagem do documento.';
brazilLangs[LangIds.ACCEPT_Terms1] = 'Aceito os ';
brazilLangs[LangIds.ACCEPT_Terms2] = 'Termos de Uso';
brazilLangs[LangIds.ACCEPT_Terms3] = ' e a';
brazilLangs[LangIds.ACCEPT_Terms4] = 'Política de Privacidade';
brazilLangs[LangIds.ACCEPT_Terms5] = ' para usar o FaceTicket. Dou meu consentimento explícito para o processamento e o armazenamento de meus dados pessoais com a finalidade de entrar no local do evento.';
brazilLangs[LangIds.ACCEPT_Sharing] = 'Aceito compartilhar meus dados para receber comunicação personalizada dos organizadores do evento.';

brazilLangs[LangIds.SELFIE_Header] = 'Tire uma selfie';
brazilLangs[LangIds.SELFIE_Headnum] = '3/4';
brazilLangs[LangIds.SELFIE_Name] = 'Vamos tirar uma selfie';
brazilLangs[LangIds.SELFIE_Desc1] = 'Mantenha o telefone na vertical';
brazilLangs[LangIds.SELFIE_Desc2] = ' e na altura dos olhos ao tirar a foto do seu rosto.';
brazilLangs[LangIds.SELFIE_Take] = 'Tire uma selfie';
brazilLangs[LangIds.SELFIE_Terms1] = 'Dávam výslovný súhlas so spracovaním a uchovávaním mojich osobných údajov na účely vstupu na miesto konania podujatia. Potvrdzujem, že som si prečítal, porozumel a súhlasím s ';
brazilLangs[LangIds.SELFIE_Terms2] = 'Podmienkami používania';

brazilLangs[LangIds.PROCESS_Processing] = 'Em processamento....';

brazilLangs[LangIds.ERROR_Retake] = 'Retomar';

brazilLangs[LangIds.MAIN_Selfie] = 'Tire uma selfie';
brazilLangs[LangIds.MAIN_Remove] = 'Remover clientes';
brazilLangs[LangIds.MAIN_RemoveSucceeded] = 'Remoção bem-sucedida';
brazilLangs[LangIds.MAIN_RemoveSucceededText] = 'Você cancelou sua compra com sucesso.';
brazilLangs[LangIds.MAIN_RemoveVisitor] = 'Remover o cliente %VISITORNAME% incluindo todos os ingressos?';
brazilLangs[LangIds.MAIN_Capture] = 'Captura de documento de identidade';
brazilLangs[LangIds.MAIN_HeaderNum1] = '1/4';
brazilLangs[LangIds.MAIN_HeaderNum2] = '2/4';
brazilLangs[LangIds.MAIN_HeaderNum3] = '3/4';
brazilLangs[LangIds.MAIN_HeaderNum4] = '4/4';
brazilLangs[LangIds.MAIN_Child] = 'Verificação de ingressos para crianças';
brazilLangs[LangIds.MAIN_ChildSucceeded] = 'Verificação bem-sucedida';
brazilLangs[LangIds.MAIN_ChildSucceededText] = 'Enviamos uma confirmação do ingresso para seu e-mail.';
brazilLangs[LangIds.MAIN_Results] = 'Resultado';
brazilLangs[LangIds.MAIN_ResultsSucceeded] = 'Verificação bem-sucedida';
brazilLangs[LangIds.MAIN_ResultsSucceededText] = 'Enviamos uma confirmação do ingresso para seu e-mail.';
brazilLangs[LangIds.MAIN_Retake] = 'Você realmente deseja registrar seus dados novamente?';
brazilLangs[LangIds.MAIN_Review] = 'Verificar detalhes';

brazilLangs[LangIds.SCANID_Capture] = 'Escaneie documento de identidade';
brazilLangs[LangIds.SCANID_Front] = 'Parte frontal';
brazilLangs[LangIds.SCANID_Back] = 'Parte traseira';
brazilLangs[LangIds.SCANID_candidate_selection] = 'Fique quieto...';
brazilLangs[LangIds.SCANID_document_centering] = 'Mover o documento para dentro do retângulo';
brazilLangs[LangIds.SCANID_document_not_present] = 'Mover o documento para dentro do retângulo';
brazilLangs[LangIds.SCANID_document_too_far] = 'Aproxime-se';
brazilLangs[LangIds.SCANID_sharpness_too_low] = 'Mais luz necessária';
brazilLangs[LangIds.SCANID_brightness_too_low] = 'Mais luz necessária';
brazilLangs[LangIds.SCANID_brightness_too_high] = 'Menos luz necessária';
brazilLangs[LangIds.SCANID_hotspots_present] = 'Evite reflexos';
brazilLangs[LangIds.SCANID_loading] = 'Carregando. Por favor, aguarde.';
brazilLangs[LangIds.SCANID_waiting] = 'Processando. Por favor, aguarde.';

brazilLangs[LangIds.SCANFACE_Selfie] = 'Tire uma selfie';
brazilLangs[LangIds.SCANFACE_candidate_selection] = 'Fique quieto...';
brazilLangs[LangIds.SCANFACE_face_too_close] = 'Volte';
brazilLangs[LangIds.SCANFACE_face_too_far] = 'Aproxime-se';
brazilLangs[LangIds.SCANFACE_face_centering] = 'Centralize o rosto';
brazilLangs[LangIds.SCANFACE_face_not_present] = 'Posicione seu rosto em um círculo';
brazilLangs[LangIds.SCANFACE_sharpness_too_low] = 'Vire seu rosto para a luz';
brazilLangs[LangIds.SCANFACE_brightness_too_low] = 'Vire seu rosto para a luz';
brazilLangs[LangIds.SCANFACE_brightness_too_high] = 'Menos luz necessária';
brazilLangs[LangIds.SCANFACE_device_pitched] = 'Mantenha o telefone na altura dos olhos';
brazilLangs[LangIds.SCANFACE_loading] = 'Carregando. Por favor, aguarde.';
brazilLangs[LangIds.SCANFACE_waiting] = 'Carregando. Por favor, aguarde.';

brazilLangs[LangIds.SUMMARY_Header] = 'Verifique os detalhes';
brazilLangs[LangIds.SUMMARY_Headnum] = '2/4';
brazilLangs[LangIds.SUMMARY_Email] = 'E-Mail';
brazilLangs[LangIds.SUMMARY_EmailError] = 'Seu endereço de e-mail não é válido.';
brazilLangs[LangIds.SUMMARY_Age] = 'Idade';
brazilLangs[LangIds.SUMMARY_AgeError] = 'Sua idade não é um número válido.';
brazilLangs[LangIds.SUMMARY_Gender] = 'Gênero';
brazilLangs[LangIds.SUMMARY_GenderError] = 'Digite seu gênero.';
brazilLangs[LangIds.SUMMARY_GivenNames] = 'Nome próprio';
brazilLangs[LangIds.SUMMARY_GivenNamesError] = 'Digite seus primeiros nomes.';
brazilLangs[LangIds.SUMMARY_Surname] = 'Sobrenome';
brazilLangs[LangIds.SUMMARY_SurnameError] = 'Digite seu sobrenome.';
brazilLangs[LangIds.SUMMARY_Fullname] = 'Nome completo';
brazilLangs[LangIds.SUMMARY_FullnameError] = 'Digite seu nome completo.';
brazilLangs[LangIds.SUMMARY_Address] = 'Endereço';
brazilLangs[LangIds.SUMMARY_AddressError] = 'Digite seu endereço.';
brazilLangs[LangIds.SUMMARY_DateOfBirth] = 'Data de nascimento';
brazilLangs[LangIds.SUMMARY_DateOfBirthError] = 'Digite sua data de nascimento.';
brazilLangs[LangIds.SUMMARY_PersonalNumber] = 'Número de identificação ';
brazilLangs[LangIds.SUMMARY_PersonalNumberError] = 'Digite seu número de identificação.';
brazilLangs[LangIds.SUMMARY_Citizenship] = 'Cidadania';
brazilLangs[LangIds.SUMMARY_CitizenshipError] = 'Informe sua cidadania.';
brazilLangs[LangIds.SUMMARY_Nationality] = 'Nacionalidade';
brazilLangs[LangIds.SUMMARY_NationalityError] = 'Digite sua nacionalidade.';
brazilLangs[LangIds.SUMMARY_DocCountry] = 'País de emissão do documento';
brazilLangs[LangIds.SUMMARY_DocCountryError] = 'Digite o país de emissão de seu documento.';
brazilLangs[LangIds.SUMMARY_DocEdition] = 'Versão do documento';
brazilLangs[LangIds.SUMMARY_DocEditionError] = 'Digite a versão de seu documento.'; 
brazilLangs[LangIds.SUMMARY_DocType] = 'Tipo de documento';
brazilLangs[LangIds.SUMMARY_DocTypeError] = 'Digite seu tipo de documento.';
brazilLangs[LangIds.SUMMARY_DocIssue] = 'Versão do documento';
brazilLangs[LangIds.SUMMARY_DocIssueError] = 'Digite a versão de seu documento.'; 
brazilLangs[LangIds.SUMMARY_DocExpiry] = 'Data de expiração';
brazilLangs[LangIds.SUMMARY_DocExpiryError] = 'Digite a data de validade de seu documento.';
brazilLangs[LangIds.SUMMARY_DocNumber] = 'Número do documento';
brazilLangs[LangIds.SUMMARY_DocNumberError] = 'Digite seu número de documento.';
brazilLangs[LangIds.SUMMARY_Retake] = 'Digite novamente';

brazilLangs[LangIds.SERVER_Err] = 'Algo deu errado. Tente novamente.';
brazilLangs[LangIds.SERVER_Err_front_fail] = 'A digitalização do documento falhou.';
brazilLangs[LangIds.SERVER_Err_front_fail_ext] = 'Digitalize a parte da FRENTE de seu documento de identidade.';
brazilLangs[LangIds.SERVER_Err_front_exp] = 'Seu documento de identidade está vencido';
brazilLangs[LangIds.SERVER_Err_front_exp_ext] = 'Você não pode continuar.';
brazilLangs[LangIds.SERVER_Err_front_change] = 'Desculpe, parece haver um problema com seu documento de identidade';
brazilLangs[LangIds.SERVER_Err_front_change_ext] = 'Você não pode continuar.';
brazilLangs[LangIds.SERVER_Err_back_fail] = 'A digitalização do documento falhou.';
brazilLangs[LangIds.SERVER_Err_back_fail_ext] = 'Digitalize a parte de trás de seu documento de identidade.';
brazilLangs[LangIds.SERVER_Err_back_exp] = 'Seu documento de identidade está vencido';
brazilLangs[LangIds.SERVER_Err_back_exp_ext] = 'Você não pode continuar.';
brazilLangs[LangIds.SERVER_Err_back_change] = 'Desculpe, parece haver um problema com seu documento de identidade.';
brazilLangs[LangIds.SERVER_Err_back_change_ext] = 'Você não pode continuar.';
brazilLangs[LangIds.SERVER_Err_face_in] = 'Seu rosto está vinculado a outro ingresso';
brazilLangs[LangIds.SERVER_Err_face_in_ext] = 'Comece do início com outro portador de ingresso.';
brazilLangs[LangIds.SERVER_Err_face_liveness] = 'Falha na verificação do rosto';
brazilLangs[LangIds.SERVER_Err_face_liveness_ext] = 'Parece que a selfie que você tirou não tem qualidade suficiente.';
brazilLangs[LangIds.SERVER_Err_face_ban] = 'Você não tem permissão para comprar ingressos devido à proibição atual do estádio';
brazilLangs[LangIds.SERVER_Err_face_ban_ext] = 'Comece do início com outro portador de ingresso.';
brazilLangs[LangIds.SERVER_Err_face_spoof] = 'Falha na verificação do rosto';
brazilLangs[LangIds.SERVER_Err_face_spoof_ext] = 'O rosto em seu documento de identidade não corresponde à selfie.';
brazilLangs[LangIds.SERVER_Err_child_in] = 'Seu rosto está vinculado a outro ingresso';
brazilLangs[LangIds.SERVER_Err_child_in_ext] = 'Comece do início com outro portador de ingresso.';
brazilLangs[LangIds.SERVER_Err_child_liveness] = 'Falha na verificação do rosto';
brazilLangs[LangIds.SERVER_Err_child_liveness_ext] = 'Parece que a selfie que você tirou não tem qualidade suficiente.';
brazilLangs[LangIds.SERVER_Err_child_ban] = 'Você não tem permissão para comprar ingressos devido à proibição atual do estádio';
brazilLangs[LangIds.SERVER_Err_child_ban_ext] = 'Comece do início com outro portador de ingresso.';
brazilLangs[LangIds.SERVER_Err_child_spoof] = 'Falha na verificação do rosto';
brazilLangs[LangIds.SERVER_Err_child_spoof_ext] = 'O rosto em seu documento de identidade não corresponde à selfie.';
brazilLangs[LangIds.SERVER_Err_child_old] = 'Parece que você tem mais de 15 anos de idade';
brazilLangs[LangIds.SERVER_Err_child_old_ext] = 'Comece do início com outro portador de ingresso.';
/*-----------------------------------BRAZIL--------------------------------------*/

/*-----------------------------------SPANISH-------------------------------------*/
var spanishLangs: string[] = [];
spanishLangs[LangIds.BUTTON_Continue] = 'Siguiente';
spanishLangs[LangIds.LOGO_Powered] = 'DESARROLLADO POR';

spanishLangs[LangIds.TURN_Doc] = 'Gire el documento hacia el reverso';

spanishLangs[LangIds.TIPS_Head1] = 'Consejos para la exitosa ';
spanishLangs[LangIds.TIPS_Head2] = 'captura del documento';
spanishLangs[LangIds.TIPS_Lightning1] = 'Asegúrate de que la habitación ';
spanishLangs[LangIds.TIPS_Lightning2] = ' está bien iluminada';
spanishLangs[LangIds.TIPS_Lightning3] = ' ';
spanishLangs[LangIds.TIPS_Table1] = 'Coloque el ';
spanishLangs[LangIds.TIPS_Table2] = 'documento de identidad sobre una mesa';
spanishLangs[LangIds.TIPS_Table3] = ' de otro color al hacer la foto';
spanishLangs[LangIds.TIPS_reflections1] = 'Para ';
spanishLangs[LangIds.TIPS_reflections2] = 'evitar reflejos';
spanishLangs[LangIds.TIPS_reflections3] = ' en el documento, colóquelo de espaldas a la luz';

spanishLangs[LangIds.ACCEPT_ErrAccept] = 'Debe aceptar los términos y condiciones para continuar.';
spanishLangs[LangIds.ACCEPT_Lets] = 'Empecemos';
spanishLangs[LangIds.ACCEPT_First] = 'Primero capturarás ambas caras de tu documento de identidad válido mientras extraemos tus datos para que no tengas que introducirlos manualmente. A continuación, te harás un selfie para compararlo con la imagen del documento.';
spanishLangs[LangIds.ACCEPT_Terms1] = 'Acepto las ';
spanishLangs[LangIds.ACCEPT_Terms2] = 'Condiciones de uso';
spanishLangs[LangIds.ACCEPT_Terms3] = ' y la';
spanishLangs[LangIds.ACCEPT_Terms4] = 'Política de privacidad';
spanishLangs[LangIds.ACCEPT_Terms5] = ' para utilizar FaceTicket. Doy mi consentimiento explícito para el tratamiento y almacenamiento de mis datos personales para entrar en el recinto.';
spanishLangs[LangIds.ACCEPT_Sharing] = 'Acepto compartir mis datos para recibir comunicaciones personalizadas de los organizadores del evento.';

spanishLangs[LangIds.SELFIE_Header] = 'Hazte un selfie';
spanishLangs[LangIds.SELFIE_Headnum] = '3/4';
spanishLangs[LangIds.SELFIE_Name] = 'Hazte un selfie';
spanishLangs[LangIds.SELFIE_Desc1] = 'Mantenga el teléfono en vertical';
spanishLangs[LangIds.SELFIE_Desc2] = ' y a la altura de los ojos cuando se haga la foto de su cara.';
spanishLangs[LangIds.SELFIE_Take] = 'Hazte un selfie';
spanishLangs[LangIds.SELFIE_Terms1] = 'Dávam výslovný súhlas so spracovaním a uchovávaním mojich osobných údajov na účely vstupu na miesto konania podujatia. Potvrdzujem, že som si prečítal, porozumel a súhlasím s ';
spanishLangs[LangIds.SELFIE_Terms2] = 'Podmienkami používania';

spanishLangs[LangIds.PROCESS_Processing] = 'Procesando....';

spanishLangs[LangIds.ERROR_Retake] = 'Retomar';

spanishLangs[LangIds.MAIN_Selfie] = 'Hazte un selfie';
spanishLangs[LangIds.MAIN_Remove] = 'Eliminar clientes';
spanishLangs[LangIds.MAIN_RemoveSucceeded] = 'Eliminación exitosa';
spanishLangs[LangIds.MAIN_RemoveSucceededText] = 'Ha cancelado correctamente su compra.';
spanishLangs[LangIds.MAIN_RemoveVisitor] = '¿Eliminar el cliente %CUSTOMERNAME% incluyendo todas las entradas?';
spanishLangs[LangIds.MAIN_Capture] = 'Captura del documento de identidad';
spanishLangs[LangIds.MAIN_HeaderNum1] = '1/4';
spanishLangs[LangIds.MAIN_HeaderNum2] = '2/4';
spanishLangs[LangIds.MAIN_HeaderNum3] = '3/4';
spanishLangs[LangIds.MAIN_HeaderNum4] = '4/4';
spanishLangs[LangIds.MAIN_Child] = 'Verificación de entradas para niños';
spanishLangs[LangIds.MAIN_ChildSucceeded] = 'Verificación exitosa';
spanishLangs[LangIds.MAIN_ChildSucceededText] = 'Le enviaremos una confirmación de su entrada por correo electrónico.';
spanishLangs[LangIds.MAIN_Results] = 'Resultado';
spanishLangs[LangIds.MAIN_ResultsSucceeded] = 'Verificación exitosa';
spanishLangs[LangIds.MAIN_ResultsSucceededText] = 'Le enviaremos una confirmación de su entrada por correo electrónico.';
spanishLangs[LangIds.MAIN_Retake] = '¿De verdad quiere registrar sus datos de nuevo?';
spanishLangs[LangIds.MAIN_Review] = 'Comprobar detalles';

spanishLangs[LangIds.SCANID_Capture] = 'Escanee su documento de identidad';
spanishLangs[LangIds.SCANID_Front] = 'Parte delantera';
spanishLangs[LangIds.SCANID_Back] = 'Parte trasera';
spanishLangs[LangIds.SCANID_candidate_selection] = 'No te muevas';
spanishLangs[LangIds.SCANID_document_centering] = 'Mueve el documento al centro del rectángulo.';
spanishLangs[LangIds.SCANID_document_not_present] = 'Mueve el documento al centro del rectángulo.';
spanishLangs[LangIds.SCANID_document_too_far] = 'Acérquese.';
spanishLangs[LangIds.SCANID_sharpness_too_low] = 'Hace falta más luz';
spanishLangs[LangIds.SCANID_brightness_too_low] = 'Hace falta más luz';
spanishLangs[LangIds.SCANID_brightness_too_high] = 'Menos luz necesaria';
spanishLangs[LangIds.SCANID_hotspots_present] = 'Evite reflejos';
spanishLangs[LangIds.SCANID_loading] = 'Cargando. Por favor, espere.';
spanishLangs[LangIds.SCANID_waiting] = 'Procesando. Por favor, espere.';

spanishLangs[LangIds.SCANFACE_Selfie] = 'Hazte un selfie';
spanishLangs[LangIds.SCANFACE_candidate_selection] = 'No te muevas';
spanishLangs[LangIds.SCANFACE_face_too_close] = 'Retrocede';
spanishLangs[LangIds.SCANFACE_face_too_far] = 'Acérquese.';
spanishLangs[LangIds.SCANFACE_face_centering] = 'Centra la cara';
spanishLangs[LangIds.SCANFACE_face_not_present] = 'Coloque la cara en círculo';
spanishLangs[LangIds.SCANFACE_sharpness_too_low] = 'Gira la cara hacia la luz';
spanishLangs[LangIds.SCANFACE_brightness_too_low] = 'Gira la cara hacia la luz';
spanishLangs[LangIds.SCANFACE_brightness_too_high] = 'Menos luz necesaria';
spanishLangs[LangIds.SCANFACE_device_pitched] = 'Mantenga el teléfono a la altura de los ojos';
spanishLangs[LangIds.SCANFACE_loading] = 'Cargando. Por favor, espere.';
spanishLangs[LangIds.SCANFACE_waiting] = 'Cargando. Por favor, espere.';

spanishLangs[LangIds.SUMMARY_Header] = 'Compruebe los detalles';
spanishLangs[LangIds.SUMMARY_Headnum] = '2/4';
spanishLangs[LangIds.SUMMARY_Email] = 'Correo electrónico';
spanishLangs[LangIds.SUMMARY_EmailError] = 'Su dirección de correo electrónico no es válida.';
spanishLangs[LangIds.SUMMARY_Age] = 'Edad';
spanishLangs[LangIds.SUMMARY_AgeError] = 'Su edad no es un número válido.';
spanishLangs[LangIds.SUMMARY_Gender] = 'Género';
spanishLangs[LangIds.SUMMARY_GenderError] = 'Introduzca su género.';
spanishLangs[LangIds.SUMMARY_GivenNames] = 'Nombre';
spanishLangs[LangIds.SUMMARY_GivenNamesError] = 'Introduzca sus nombres.';
spanishLangs[LangIds.SUMMARY_Surname] = 'Apellido';
spanishLangs[LangIds.SUMMARY_SurnameError] = 'Introduzca su apellido.';
spanishLangs[LangIds.SUMMARY_Fullname] = 'Nombre completo';
spanishLangs[LangIds.SUMMARY_FullnameError] = 'Introduzca su nombre completo.';
spanishLangs[LangIds.SUMMARY_Address] = 'Dirección';
spanishLangs[LangIds.SUMMARY_AddressError] = 'Introduzca su dirección.';
spanishLangs[LangIds.SUMMARY_DateOfBirth] = 'Fecha de nacimiento';
spanishLangs[LangIds.SUMMARY_DateOfBirthError] = 'Introduzca su fecha de nacimiento.';
spanishLangs[LangIds.SUMMARY_PersonalNumber] = 'Número de identificación ';
spanishLangs[LangIds.SUMMARY_PersonalNumberError] = 'Introduzca su número de identificación.';
spanishLangs[LangIds.SUMMARY_Citizenship] = 'Ciudadanía';
spanishLangs[LangIds.SUMMARY_CitizenshipError] = 'Introduzca su ciudadanía.';
spanishLangs[LangIds.SUMMARY_Nationality] = 'Nacionalidad';
spanishLangs[LangIds.SUMMARY_NationalityError] = 'Introduzca su nacionalidad.';
spanishLangs[LangIds.SUMMARY_DocCountry] = 'País de emisión del documento';
spanishLangs[LangIds.SUMMARY_DocCountryError] = 'Introduzca el país de emisión del documento.';
spanishLangs[LangIds.SUMMARY_DocEdition] = 'Versión del documento';
spanishLangs[LangIds.SUMMARY_DocEditionError] = 'Introduzca la versión de su documento.'; 
spanishLangs[LangIds.SUMMARY_DocType] = 'Tipo de documento';
spanishLangs[LangIds.SUMMARY_DocTypeError] = 'Introduzca el tipo de documento.';
spanishLangs[LangIds.SUMMARY_DocIssue] = 'Versión del documento';
spanishLangs[LangIds.SUMMARY_DocIssueError] = 'Introduzca la versión de su documento.'; 
spanishLangs[LangIds.SUMMARY_DocExpiry] = 'Fecha de caducidad';
spanishLangs[LangIds.SUMMARY_DocExpiryError] = 'Introduzca la fecha de caducidad de su documento.';
spanishLangs[LangIds.SUMMARY_DocNumber] = 'Número de documento';
spanishLangs[LangIds.SUMMARY_DocNumberError] = 'Introduzca su número de documento.';
spanishLangs[LangIds.SUMMARY_Retake] = 'Retomar';

spanishLangs[LangIds.SERVER_Err] = 'Algo ha salido mal. Vuelve a intentarlo.';
spanishLangs[LangIds.SERVER_Err_front_fail] = 'Captura del documento ha fallado';
spanishLangs[LangIds.SERVER_Err_front_fail_ext] = 'Captura el FRENTE de su documento de identidad.';
spanishLangs[LangIds.SERVER_Err_front_exp] = 'Su documento de identidad ha caducado';
spanishLangs[LangIds.SERVER_Err_front_exp_ext] = 'No puede continuar.';
spanishLangs[LangIds.SERVER_Err_front_change] = 'Lo sentimos, parece que hay un problema con su documento de identidad.';
spanishLangs[LangIds.SERVER_Err_front_change_ext] = 'No puede continuar.';
spanishLangs[LangIds.SERVER_Err_back_fail] = 'Captura del documento ha fallado.';
spanishLangs[LangIds.SERVER_Err_back_fail_ext] = 'Captura el REVERSO de su documento de identidad.';
spanishLangs[LangIds.SERVER_Err_back_exp] = 'Su documento de identidad ha caducado';
spanishLangs[LangIds.SERVER_Err_back_exp_ext] = 'No puede continuar.';
spanishLangs[LangIds.SERVER_Err_back_change] = 'Lo sentimos, parece que hay un problema con su documento de identidad.';
spanishLangs[LangIds.SERVER_Err_back_change_ext] = 'No puede continuar.';
spanishLangs[LangIds.SERVER_Err_face_in] = 'Su cara está vinculada a otra entrada';
spanishLangs[LangIds.SERVER_Err_face_in_ext] = 'Comience desde el principio con otro titular de la entrada.';
spanishLangs[LangIds.SERVER_Err_face_liveness] = 'Verificación facial ha fallado';
spanishLangs[LangIds.SERVER_Err_face_liveness_ext] = 'Parece que el selfie no tiene suficiente calidad.';
spanishLangs[LangIds.SERVER_Err_face_ban] = 'No puede comprar entradas debido a la prohibición vigente en el estadio';
spanishLangs[LangIds.SERVER_Err_face_ban_ext] = 'Comience desde el principio con otro titular de la entrada.';
spanishLangs[LangIds.SERVER_Err_face_spoof] = 'Verificación facial ha fallado';
spanishLangs[LangIds.SERVER_Err_face_spoof_ext] = 'La cara de su documento de identidad no corresponde al selfie.';
spanishLangs[LangIds.SERVER_Err_child_in] = 'Su cara está vinculada a otra entrada';
spanishLangs[LangIds.SERVER_Err_child_in_ext] = 'Comience desde el principio con otro titular de la entrada.';
spanishLangs[LangIds.SERVER_Err_child_liveness] = 'Verificación facial ha fallado';
spanishLangs[LangIds.SERVER_Err_child_liveness_ext] = 'Parece que el selfie no tiene suficiente calidad.';
spanishLangs[LangIds.SERVER_Err_child_ban] = 'No puede comprar entradas debido a la prohibición vigente en el estadio';
spanishLangs[LangIds.SERVER_Err_child_ban_ext] = 'Comience desde el principio con otro titular de la entrada.';
spanishLangs[LangIds.SERVER_Err_child_spoof] = 'Verificación facial ha fallado';
spanishLangs[LangIds.SERVER_Err_child_spoof_ext] = 'La cara de su documento de identidad no corresponde al selfie.';
spanishLangs[LangIds.SERVER_Err_child_old] = 'Parece que tengas más de 15 años de edad';
spanishLangs[LangIds.SERVER_Err_child_old_ext] = 'Comience desde el principio con otro titular de la entrada.';
/*-----------------------------------SPANISH-------------------------------------*/

export function getLang(id: LangIds, lang:Languages){

  switch (lang){
    case Languages.DUTCH:
      return dutchLangs[id];

    case Languages.FRENCH:
      return frenchLangs[id];

    case Languages.GERMAN:
      return germanLangs[id];

    case Languages.SLOVAK:
      return slovakLangs[id];

    case Languages.BRAZIL:
      return brazilLangs[id];

    case Languages.SPANISH:
      return spanishLangs[id];

    case Languages.ENGLISH:
    default:
      return englishLangs[id];
  }
}
